{
  "LOGIN": {
    "TITLE": "Welcome back",
    "SUBTITLE": "Enter your credentials to access your account",
    "EMAIL_PLACEHOLDER": "you@example.com",
    "PASSWORD_LABEL": "Password",
    "SUBMIT": "Sign in",
    "SUBMITTING": "Signing in...",
    "QUICK_LOGIN": "Quick access",
    "QUICK_SUPER_ADMIN": "Super Admin",
    "QUICK_ADMIN": "Admin",
    "FORGOT_PASSWORD": "Forgot password?"
  },

  "FORGOT_PASSWORD": {
    "TITLE": "Reset password",
    "SUBTITLE": "Enter your email and we'll send you instructions",
    "CHECK_INBOX": "Check your inbox",
    "EMAIL_SENT": "We've sent a recovery link to your email",
    "EMAIL_LABEL": "Email Address",
    "EMAIL_PLACEHOLDER": "name@company.com",
    "SEND_INSTRUCTIONS": "Send instructions",
    "SENDING": "Sending...",
    "SENT_TO": "Sent to",
    "CHECK_SPAM": "Did not receive the email? Check your spam folder or try again.",
    "TRY_ANOTHER_EMAIL": "Try another email",
    "BACK_TO_LOGIN": "Back to login"
  },

  "MOBILE": {
    "HUB_TITLE": "Welty",
    "HUB_SCREEN_TITLE": "Home",
    "BACK": "Back"
  },

  "PWA_INSTALL": {
    "BANNER_LABEL": "Install app",
    "TITLE": "Install Welty on your phone",
    "ANDROID_HINT": "Add Welty to your home screen for quick access.",
    "ANDROID_MANUAL": "Open the browser menu (⋮), then tap “Install app” or “Add to Home screen”. On a dev server over Wi‑Fi this button may be missing — use “Add to Home screen” from the same menu.",
    "IOS_INSTRUCTIONS": "Tap the Share button, then choose “Add to Home Screen”.",
    "INSTALL": "Install",
    "LATER": "Not now"
  },

  "COMMON": {
    "LOGOUT": "Logout",
    "ACTIONS": "Actions",
    "LOADING": "Loading...",
    "SAVING": "Saving...",
    "SELECT_PLACEHOLDER": "Select...",
    "PER_PAGE": "per page",
    "PREV": "Prev",
    "NEXT": "Next",
    "NO_DATA": "No data",
    "CANCEL": "Cancel",
    "ERROR": "Error",
    "EDIT": "Edit",
    "CLOSE": "Close",
    "SAVE": "Save",
    "SAVE_SUCCESS": "Saved successfully.",
    "CREATE_SUCCESS": "Created successfully.",
    "UPDATE_SUCCESS": "Updated successfully.",
    "DELETE_SUCCESS": "Deleted successfully.",
    "COPIED": "Copied to clipboard.",
    "COPY_FAILED": "Could not copy."
  },

  "CONFIRM_MODAL": {
    "CONFIRM": "Confirm",
    "CANCEL": "Cancel",
    "DELETE": "Delete"
  },

  "ADMIN": {
    "OVERVIEW": "Overview",
    "TENANTS": "Tenants",
    "ACCOUNT": "Account",
    "SHOWCASE": "Showcase",
    "TENANT_BLOCK_CONFIRM_TITLE": "Confirm block",
    "TENANT_BLOCK_CONFIRM_MESSAGE": "Are you sure you want to block this tenant?\n<strong>{{name}}</strong>",
    "TENANT_UNBLOCK_CONFIRM_TITLE": "Confirm unblock",
    "TENANT_UNBLOCK_CONFIRM_MESSAGE": "Are you sure you want to unblock this tenant?\n<strong>{{name}}</strong>",
    "TENANT_REMOVE_USER_CONFIRM_TITLE": "Confirm removal",
    "TENANT_REMOVE_USER_CONFIRM_MESSAGE": "Are you sure you want to remove this user from the tenant?\n<strong>{{name}}</strong>",
    "TENANT_INVITE_DELETE_CONFIRM_TITLE": "Cancel invite",
    "TENANT_INVITE_DELETE_CONFIRM_MESSAGE": "Are you sure you want to cancel this invite?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RENEW_CONFIRM_TITLE": "Renew invite",
    "TENANT_INVITE_RENEW_CONFIRM_MESSAGE": "Are you sure you want to renew this invite?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RESEND_CONFIRM_TITLE": "Resend invite",
    "TENANT_INVITE_RESEND_CONFIRM_MESSAGE": "Are you sure you want to resend this invite?\n<strong>{{email}}</strong>",
    "USER_ROLE_UPDATE_ERROR": "Could not update user role.",
    "INVITES_LOAD_FAILED": "Could not load invitations.",
    "INVITE_CREATE_FAILED": "Could not create invitation.",
    "INVITE_RENEW_FAILED": "Could not renew invitation.",
    "INVITE_RESEND_FAILED": "Could not resend invitation.",
    "INVITE_DELETE_FAILED": "Could not cancel invitation.",
    "INVITE_RENEWED_SUCCESS": "Invitation renewed. A new email was sent.",
    "INVITE_RESENT_SUCCESS": "Invitation resent successfully.",
    "SUPER_ADMIN_INVITE_FAILED": "Could not send invitation.",
    "WHATSAPP": {
      "TITLE": "WhatsApp / Twilio",
      "SYNC_TWILIO": "Sync numbers from Twilio",
      "PENDING_REQUESTS": "Pending connection requests",
      "NO_PENDING": "No pending requests.",
      "COL_TENANT": "Tenant",
      "COL_NUMBER": "Assign number",
      "COL_ASSIGNED": "Assigned tenant",
      "COL_E164": "E.164",
      "COL_SID": "SID",
      "USAGE_CATEGORY": "Category",
      "USAGE_COUNT": "Count",
      "USAGE_PRICE": "Price",
      "SELECT_NUMBER": "Select a number…",
      "APPROVE": "Approve",
      "REJECT": "Reject",
      "NO_INVENTORY": "No phone numbers in inventory. Sync from Twilio to load numbers.",
      "INVENTORY": "Phone number inventory",
      "USAGE": "Usage (Twilio)",
      "COL_ACTIONS": "Actions",
      "DISCONNECT": "Disconnect",
      "DISCONNECT_CONFIRM": "Disconnect WhatsApp for the tenant using {{e164}}? The number will be available for reassignment.",
      "DISCONNECT_SUCCESS": "WhatsApp disconnected. The number is available again.",
      "DISCONNECT_ERROR": "Could not disconnect WhatsApp for this tenant."
    }
  },

  "NAV": {
    "DASHBOARD": "Dashboard",
    "CONVERSATIONS": "Conversations",
    "NOTIFICATIONS": "Notifications",
    "CONTACTS": "Contacts",
    "KNOWLEDGE_BASE": "Knowledge Base",
    "FLOWS": "Flows",
    "SERVICES": "Services",
    "APPOINTMENTS": "Appointments",
    "COLLABORATORS": "Collaborators",
    "INSIGHTS": "Insights",
    "FLOOR_PLAN": "Floor Plan",
    "FLOOR_PLAN_LIVE": "Dining room (live)",
    "FLOOR_PLAN_ANALYTICS": "Dining analytics",
    "FOOD_SETTINGS": "Restaurant settings",
    "SETTINGS": "Settings",
    "SECTION_FOOD": "Food services",
    "SECTION_PERSONAL_CARE": "Personal care"
  },

  "FOOD_SETTINGS": {
    "TITLE": "Restaurant & booking settings",
    "SUBTITLE": "Opening hours apply to chat table booking and to staff reservations in the live dining room. Each weekday uses UTC (same as operational calendar dates).",
    "HERO_EYEBROW": "Food · Reservations",
    "LOADING": "Loading…",
    "SAVE": "Save",
    "SAVE_SUCCESS": "Restaurant settings saved.",
    "ERROR_LOAD": "Could not load restaurant settings.",
    "ERROR_SAVE": "Could not save restaurant settings.",
    "INVALID_DAY_HOURS": "One or more times are invalid. Use 24-hour times (hours 00–23, minutes 00–59).",
    "MISSING_DAY_HOURS": "Set both opening and closing time for each open day.",
    "MISSING_DAY_INTERVALS": "Each open day needs at least one opening window with open and close times.",
    "CLOSE_NOT_AFTER_OPEN": "Closing time must be after opening on the same calendar day, unless you use overnight hours (closing earlier than opening, e.g. 22:00–02:00).",
    "SAME_OPEN_CLOSE": "Opening and closing time cannot be the same.",
    "OVERNIGHT_LIMIT": "Only one overnight window per day is allowed (for example 22:00–02:00).",
    "OVERLAPPING_INTERVALS": "Same-day opening windows cannot overlap.",
    "ADD_INTERVAL": "Add opening hours",
    "REMOVE_INTERVAL_ARIA": "Remove this opening window",
    "INVALID_WEEKLY_SHAPE": "Weekly hours data is incomplete. Reload the page and try again.",
    "AT_LEAST_ONE_OPEN_DAY": "Keep at least one day open.",
    "SECTION_WEEKLY_HOURS": "Hours by day",
    "HINT_WEEKLY_UTC": "For each day, add one or more open/close windows (for example lunch and dinner), or mark closed. Weekdays are Sunday–Saturday in UTC. Closing time 00:00 means midnight at the end of that day (not the start of the next). For real overnight service (e.g. 22:00–02:00), use a closing time after 00:01.",
    "CLOSED": "Closed",
    "OPENS": "Opens",
    "CLOSES": "Closes",
    "SECTION_SLOTS": "Reservations & table turnover",
    "DURATION_MIN": "Default reservation length (minutes)",
    "MIN_DURATION": "Minimum guest stay (minutes)",
    "MAX_DURATION": "Maximum guest stay (minutes)",
    "PREP_MIN": "Prep time before seating (minutes)",
    "COOLDOWN_MIN": "Cooldown after guests leave (minutes)",
    "GRID_STEP": "Start-time grid step (minutes)",
    "BUFFER_TOTAL": "Typical blocked window per party: {{minutes}} minutes (prep + default length + cooldown).",
    "MIN_MAX_DURATION": "Minimum stay cannot be greater than maximum stay.",
    "SECTION_NO_AVAIL": "Chat: no availability message",
    "HINT_NO_AVAIL": "Shown when the chatbot cannot find a table (after trying ±30 minutes). Variables: {date}, {time}, {partySize}, {restaurant}, {phone} (business phone from your tenant profile). The chatbot must deliver this text verbatim.",
    "NO_AVAIL_TEMPLATE": "Message template",
    "NO_AVAIL_PLACEHOLDER": "Sorry, we have no tables on {date} around {time} for {partySize} guests.",
    "SECTION_PARTY_SIZE_EXCEEDED": "Chat: party too large",
    "HINT_PARTY_SIZE_EXCEEDED": "Shown when the guest count exceeds the largest table or combination on the floor plan. Variables: {partySize}, {maxPartySize}, {date}, {restaurant}, {phone}. The chatbot must deliver this text verbatim.",
    "PARTY_SIZE_EXCEEDED_TEMPLATE": "Message template",
    "PARTY_SIZE_EXCEEDED_PLACEHOLDER": "Sorry, we cannot seat {partySize} guests — our largest setup fits up to {maxPartySize}. Please call {phone} or try a smaller group.",
    "PREVIEW_LABEL": "Preview (sample values)",
    "SLOT_STEP": "Slot step (minutes)",
    "HINT_SLOTS": "Listed start times use the grid step (e.g. every 15 minutes). Prep and cooldown extend how long the table stays blocked before and after the guest window. Min/max length allow shorter or longer stays when the schedule allows (including partial slots in chat).",
    "DAY_OPEN_LABEL": "Open",
    "DAY_CLOSED_LABEL": "Closed",
    "DAY_TOGGLE_ARIA": "Open or close {{label}}",
    "DAY_OFF_HELP": "Guests cannot book on this day. Turn the switch on to set opening hours.",
    "CALLOUT_SLOTS": "Example: default stay 60 min, grid 15 min → possible starts every 15 minutes if the table is free for the full stay plus buffers. Partial slots in chat use a shorter end time when there is only a limited gap before the next booking.",
    "WEEKDAYS": {
      "D0": "Sunday",
      "D1": "Monday",
      "D2": "Tuesday",
      "D3": "Wednesday",
      "D4": "Thursday",
      "D5": "Friday",
      "D6": "Saturday"
    }
  },

  "LAYOUT": {
    "DEFAULT_SECTION_LABEL": "Personal Care",
    "CHANGE_TENANT": "Change tenant",
    "SELECT_TENANT": "Select tenant..."
  },
  "NOTIFICATIONS_PAGE": {
    "SUBTITLE": "Actionable and unread items for your tenant.",
    "UNREAD": "Unread",
    "READ": "Read",
    "ACTION_NEEDED": "Action needed",
    "EMPTY_UNREAD": "No unread notifications.",
    "EMPTY_READ": "No read notifications yet.",
    "EMPTY_ACTION_NEEDED": "No action needed at the moment.",
    "EMPTY_ALL": "No notifications.",
    "SYSTEM": "System",
    "SYSTEM_COMING_SOON": "System notifications will appear here.",
    "FILTER_ALL": "All",
    "FILTER_UNREAD": "Unread",
    "FILTER_READ": "Read",
    "FILTER_APPOINTMENTS": "Appointments",
    "FILTER_APPOINTMENTS_UNREAD": "Appointments - Unread",
    "FILTER_CHAT": "Chat",
    "FILTER_CHAT_UNREAD": "Chat - Unread",
    "FILTER_SYSTEM": "System",
    "FILTER_NEW_MEMBER": "New member",
    "TYPE_CHAT_INTERVENTION_NEEDED": "Chat intervention",
    "TYPE_SYSTEM_ERROR": "System error",
    "TYPE_APPOINTMENT_NEW": "New appointment",
    "TYPE_APPOINTMENT_CANCELLED": "Appointment cancelled",
    "TYPE_APPOINTMENT_MODIFIED": "Appointment updated",
    "TYPE_TENANT_NEW_MEMBER": "New team member",
    "COLUMN_TYPE": "Type",
    "COLUMN_TITLE": "Title",
    "COLUMN_STATUS": "Status",
    "COLUMN_DATE": "Date",
    "COLUMN_DETAILS": "Details",
    "DETAILS_CREATED_AT": "Created",
    "DETAILS_APPOINTMENT_ID": "Appointment",
    "DETAILS_ERROR_CODE": "Error code",
    "DETAILS_OPEN_CHAT": "Open chat",
    "ACTION_GO_TO_AGENDA": "Go to agenda",
    "ACTION_GO_TO_TEAM": "Go to team"
  },

  "SIDEBAR": {
    "HELP_TITLE": "Need help?",
    "HELP_TEXT": "Contact support or view guides.",
    "COLLAPSE": "Collapse sidebar",
    "EXPAND": "Expand sidebar",
    "MAIN_NAV": "Main navigation"
  },

  "SETTINGS": {
    "TABS": {
      "PROFILE": "Profile",
      "BUSINESS": "Business",
      "NOTIFICATIONS": "Notifications",
      "APPEARANCE": "Appearance",
      "SECURITY": "Security",
      "BILLING": "Billing",
      "INTEGRATIONS": "Integrations",
      "CHATBOT": "Chatbot"
    },
    "PROFILE_TITLE": "Profile settings",
    "CHANGE_PHOTO": "Change photo",
    "PHOTO_HINT": "JPG, PNG or GIF. Max 2MB.",
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "EMAIL": "Email",
    "PHONE": "Phone",
    "PROFILE_SAVED": "Profile saved successfully.",
    "SAVE_CHANGES": "Save changes",
    "SAVING": "Saving...",
    "FOOD_SETTINGS_LINK": "Open restaurant & booking settings",
    "FOOD_SETTINGS_LINK_HINT": "Opening hours, working days and reservation length are on a dedicated page.",
    "BUSINESS_TITLE": "Business details",
    "UPLOAD_LOGO": "Upload logo",
    "LOGO_HINT": "Recommended size 400x400px.",
    "COMPANY_NAME": "Company Name",
    "INDUSTRY": "Industry",
    "BUSINESS_ADDRESS": "Business Address",
    "TAX_INFO_TITLE": "Tax Information",
    "VAT_ID": "VAT ID",
    "CURRENCY": "Currency",
    "BUSINESS_SAVED": "Business info saved successfully.",
    "SAVE_BUSINESS": "Save business info",
    "COMM_PREFS_TITLE": "Notification preferences",
    "COMM_PREFS_SUBTITLE": "Delivery channels apply to everyone in this workspace. Only admins can change them; operators can link their own Telegram below.",
    "NOTIF_ROW_APPOINTMENT_NEW": "New appointment received",
    "NOTIF_ROW_APPOINTMENT_NEW_DESC": "When a client books via chatbot or forms.",
    "NOTIF_ROW_APPOINTMENT_CANCELLED": "Appointment cancelled or deleted",
    "NOTIF_ROW_APPOINTMENT_CANCELLED_DESC": "When an appointment is cancelled or removed.",
    "NOTIF_ROW_APPOINTMENT_MODIFIED": "Appointment modified",
    "NOTIF_ROW_APPOINTMENT_MODIFIED_DESC": "When date, time, service, or other details change.",
    "NOTIF_ROW_TENANT_MEMBER": "New collaborator or admin",
    "NOTIF_ROW_TENANT_MEMBER_DESC": "When someone joins your tenant team.",
    "NOTIF_ROW_HUMAN_ASSISTANT": "Human assistance needed",
    "NOTIF_ROW_HUMAN_ASSISTANT_DESC": "When a conversation needs operator attention or there is a chatbot configuration issue.",
    "NOTIF_MATRIX_EVENT": "Notification",
    "NOTIF_CHANNEL_IN_APP": "In-app list",
    "NOTIF_CHANNEL_EMAIL": "Email",
    "NOTIF_CHANNEL_TELEGRAM": "Telegram",
    "NOTIF_SAVE": "Save notification preferences",
    "NOTIF_TELEGRAM_INFO_TITLE": "Telegram notifications",
    "NOTIF_TELEGRAM_INFO_DESC": "After the notifications bot is connected (Integrations), anyone who opens the bot and presses Start will automatically receive alerts for events with Telegram enabled above. Press /stop on the bot to unsubscribe.",
    "NOTIF_TELEGRAM_OPEN_BOT": "Open bot on Telegram",
    "NOTIF_TELEGRAM_BOT_NOT_CONNECTED": "Connect the notifications bot first (Integrations tab).",
    "NOTIF_TELEGRAM_SUBSCRIBERS": "Active subscribers",
    "NOTIFICATION_PREFS": {
      "LOADING": "Loading preferences…",
      "NO_TENANT": "Select a tenant to manage notification preferences.",
      "ERROR_LOAD": "Could not load notification preferences.",
      "ERROR_SAVE": "Could not save notification preferences."
    },
    "NOTIFICATIONS_TELEGRAM_BOT_TITLE": "Notifications bot (tenant)",
    "NOTIFICATIONS_TELEGRAM_BOT_DESC": "Create a separate Telegram bot with BotFather for staff notifications only. Anyone who opens the bot and presses Start will receive alerts; this bot does not handle customer chat.",
    "NOTIFICATIONS_TELEGRAM": {
      "CONNECT": "Connect notifications bot",
      "DISCONNECT": "Disconnect bot",
      "DISCONNECT_CONFIRM_TITLE": "Disconnect notifications bot?",
      "DISCONNECT_CONFIRM_MESSAGE": "Staff will stop receiving Telegram notifications until a new bot is connected.",
      "CONNECT_ERROR": "Could not connect the notifications bot.",
      "DISCONNECT_ERROR": "Could not disconnect the notifications bot.",
      "LINK_ERROR": "Could not start Telegram linking. Ensure the notifications bot is connected and try again.",
      "UNLINK_ERROR": "Could not unlink Telegram."
    },
    "APPEARANCE_TITLE": "Look and feel",
    "AI_AUTO_DISABLE_TITLE": "AI Auto-disable",
    "AI_AUTO_DISABLE_LABEL": "Turn off AI after N missed replies",
    "AI_AUTO_DISABLE_DESC": "Set to 0 to disable this feature. After N consecutive failures, AI mode will be turned off for that chat.",
    "AI_AUTO_DISABLE_SAVED": "AI auto-disable policy saved.",
    "THEME_PREFERENCES": "Theme Preferences",
    "THEME_LIGHT": "Light",
    "THEME_DARK": "Dark",
    "SECURITY_TITLE": "Security & Login",
    "TWO_FA_TITLE": "Two-Factor Authentication",
    "TWO_FA_DESC": "Add an extra layer of security to your account by requiring more than just a password to log in.",
    "SETUP_2FA": "Setup 2FA",
    "CHANGE_PASSWORD": "Change Password",
    "CURRENT_PASSWORD": "Current Password",
    "NEW_PASSWORD": "New Password",
    "PASSWORD_UPDATED": "Password updated successfully.",
    "UPDATING": "Updating...",
    "UPDATE_PASSWORD": "Update Password",
    "ACTIVE_SESSIONS": "Active Sessions",
    "ACTIVE_NOW": "Active now",
    "LAST_ACTIVE_AGO": "Last active 2h ago",
    "BILLING_UNAVAILABLE": "Billing is not available yet.",
    "INTEGRATIONS_TITLE": "Integrations",
    "CHATBOT_TITLE": "Chatbot messages",
    "CHATBOT_IDENTIFICATION_TITLE": "Onboarding",
    "CHATBOT_KNOWLEDGE_BASE_TITLE": "Knowledge Base",
    "CHATBOT_ERRORS_TITLE": "Error Messages",
    "CHATBOT_SAVED": "Chatbot messages saved successfully.",
    "APPOINTMENT_CALENDARS": "Appointment Calendars",
    "GOOGLE_CALENDAR": "Google Calendar",
    "GOOGLE_CALENDAR_DESC": "Sync appointments automatically",
    "MANAGE_CONNECTION": "Manage Connection",
    "APPLE_CALENDAR": "Apple Calendar",
    "APPLE_CALENDAR_DESC": "Two-way sync with iCloud",
    "CONNECT": "Connect",
    "CONVERSATIONS_SECTION": "Conversations",
    "WHATSAPP_BUSINESS": "WhatsApp Business",
    "CONNECTED": "Connected:",
    "WHATSAPP_CONNECT_DESC": "Request a WhatsApp number. A super admin will assign one after approval.",
    "WHATSAPP_PENDING": "Request pending approval.",
    "WHATSAPP_REJECTED": "Your last request was rejected. You can submit a new request.",
    "REQUEST_WHATSAPP": "Request connection",
    "DISCONNECT": "Disconnect",
    "CONNECT_NUMBER": "Request connection",
    "TELEGRAM_BOT": "Telegram Bot",
    "CHATBOT": {
      "WELCOME_MESSAGE": "Hello! I'm the bot. To continue, I need some information. What's your name?",
      "WELCOME_BACK_MESSAGE": "Welcome back! How can I help you?",
      "CONFIRMATION_MESSAGE": "Thank you! You have been registered. How can I help you?",
      "FIRST_NAME_QUESTION": "What's your name? (first name)",
      "LAST_NAME_QUESTION": "What's your last name?",
      "PHONE_QUESTION": "What is your phone number? (e.g., 333 1234567)",
      "NO_INFORMATION_AVAILABLE": "I'm sorry, I don't have information about that in my knowledge base.",
      "ERROR_OCCURRED": "An error occurred. Please try again later.",
      "ERROR_LOAD": "Could not load chatbot messages.",
      "ERROR_SAVE": "Could not save chatbot messages.",
      "SYSTEM_MESSAGES": {
        "TITLE": "System messages",
        "SUBTITLE": "Customize the automatic messages the AI sends in different situations. If a field is left empty, the default text will be used.",
        "PLACEHOLDER": "Enter a custom text (optional)",
        "LABELS": {
          "WELCOME": "Welcome message",
          "KB_NOT_FOUND": "Knowledge Base: info not found",
          "SYSTEM_ERROR": "System error",
          "OUT_OF_HOURS": "Out of office hours",
          "HANDOFF_TO_HUMAN": "Handoff to human operator",
          "NO_OPERATOR_AVAILABLE": "No operator available",
          "BOOKING_CONFIRMED": "Booking confirmed",
          "BOOKING_RESCHEDULED": "Booking rescheduled",
          "BOOKING_CANCELLED": "Booking cancelled",
          "NO_AVAILABILITY_FOUND": "No availability found",
          "FORM_SENT": "Form sent to the user",
          "FORM_COMPLETED_THANKS": "Form completed — thank you",
          "INPUT_NOT_UNDERSTOOD": "Input not understood",
          "UNSUPPORTED_MEDIA": "Unsupported message (media/file)",
          "PRIVACY_CONSENT_REQUEST": "Privacy consent request (GDPR)",
          "PRIVACY_CONSENT_DENIED": "Privacy consent denied",
          "CONVERSATION_CLOSED": "Conversation closed",
          "REACTIVATION": "Reactivation message"
        }
      },
      "FOOD_DINING": {
        "TITLE": "Table reservations via chat",
        "SUBTITLE": "Food businesses only: set the Service used when the AI creates table reservations (create a “Table booking” service under Services if needed). Times use the same UTC calendar day as the floor plan.",
        "SERVICE_ID": "Table reservation service ID",
        "SERVICE_HINT": "24-character MongoDB id from your Services list.",
        "SERVICE_PLACEHOLDER": "e.g. 674a1b2c3d4e5f6789012345",
        "DURATION": "Reservation length (minutes)",
        "DAY_START": "First bookable time (HH:mm)",
        "DAY_END": "Day end boundary for last slot (HH:mm)",
        "SLOT_STEP": "Minutes between offered start times",
        "SAVE": "Save table booking settings",
        "ERROR_SAVE": "Could not save table booking settings."
      }
    },
    "TELEGRAM": {
      "SETUP_TITLE": "Configure Telegram Bot",
      "SETUP_SUBTITLE": "Follow the steps to create and configure your Telegram bot",
      "CLOSE_ARIA": "Close",
      "QR_GENERATING": "Generating QR code...",
      "QR_FALLBACK": "If the QR code does not appear, use the link below to open BotFather",
      "QR_HINT": "Scan the QR code with Telegram to open BotFather directly",
      "OPEN_BOTFATHER": "Or open BotFather manually",
      "STEPS_TITLE": "Steps to follow:",
      "STEP_1_TITLE": "Open Telegram",
      "STEP_1_DESC": "Open the Telegram app on your phone or desktop",
      "STEP_2_TITLE": "Search for BotFather",
      "STEP_2_DESC": "Search for @BotFather in the Telegram search bar",
      "STEP_3_TITLE": "Create a new bot",
      "STEP_3_DESC": "Send the /newbot command to BotFather",
      "STEP_4_TITLE": "Configure the bot",
      "STEP_4_DESC": "Choose a name and username for your bot (username must end with \"bot\")",
      "STEP_5_TITLE": "Copy the token",
      "STEP_5_DESC": "BotFather will give you a Bot Token. Copy it and paste it below",
      "BOT_TOKEN_LABEL": "Bot Token",
      "BOT_TOKEN_PLACEHOLDER": "123456789:ABCdefGHIjklMNOpqrsTUVwxyz",
      "BOT_TOKEN_HINT": "Paste here the token provided by BotFather after creating the bot",
      "TOKEN_REQUIRED": "Bot token is required",
      "TOKEN_INVALID": "Invalid token format. Token must be in the format: number:characters",
      "CANCEL": "Cancel",
      "CONNECT_BOT": "Connect Bot",
      "CONNECTING": "Connecting...",
      "QR_MODAL_TITLE": "Bot QR Code",
      "QR_MODAL_HINT": "Scan the QR code with your camera to open the bot on Telegram",
      "DOWNLOAD_QR": "Download QR image",
      "COPY_LINK": "Copy link",
      "LINK_COPIED": "Link copied",
      "SHARE_BOT_LINK": "Share your bot link",
      "OPEN_BOT_ON_TELEGRAM": "Open bot on Telegram",
      "QR_OR_SHARE": "QR code / Share",
      "BOT_CONNECTED_ACTIVE": "Bot connected and active",
      "INTEGRATE_BOT": "Integrate your bot for notifications and chat.",
      "CONFIGURE_BOT": "Configure Bot",
      "DISCONNECT_CONFIRM_TITLE": "Disconnect Telegram",
      "DISCONNECT_CONFIRM_MESSAGE": "Are you sure you want to disconnect Telegram? Messages will no longer be received.",
      "CONNECT_ERROR": "Error: please verify that the bot token is valid. Get it from @BotFather on Telegram.",
      "DISCONNECT_ERROR": "Error disconnecting Telegram."
    },
    "WHATSAPP_SHARE": {
      "CLOSE_ARIA": "Close",
      "QR_GENERATING": "Generating QR code...",
      "QR_MODAL_TITLE": "WhatsApp number",
      "QR_MODAL_HINT": "Scan the QR code with your phone to open a chat on WhatsApp",
      "QR_IMAGE_ALT": "QR code to open WhatsApp chat",
      "DOWNLOAD_QR": "Download QR image",
      "COPY_LINK": "Copy link",
      "LINK_COPIED": "Link copied",
      "SHARE_NUMBER": "Share your WhatsApp business number",
      "OPEN_ON_WHATSAPP": "Open on WhatsApp",
      "QR_OR_SHARE": "QR code / Share"
    },
    "WIDGET": {
      "TITLE": "Website Chat Widget",
      "DESCRIPTION_GENERATED": "Widget code generated. Copy the snippet to integrate the widget on your site.",
      "DESCRIPTION_NOT_GENERATED": "Generate a widget code to integrate the chatbot on your website.",
      "GENERATE_BUTTON": "Generate Widget Code",
      "REGENERATE_BUTTON": "Regenerate",
      "ENABLE_BUTTON": "Enable",
      "DISABLE_BUTTON": "Disable",
      "COPY_SNIPPET": "Copy Snippet",
      "TEST_WIDGET": "Test Widget",
      "LOADING": "Loading...",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "ERROR_NOT_GENERATED": "Widget code not generated. Generate a widget code from Settings.",
      "ERROR_LOADING": "Error loading widget status",
      "ERROR_GENERATING": "Failed to generate widget code",
      "ERROR_TOGGLE": "Failed to update widget status",
      "REGENERATE_CONFIRM_TITLE": "Regenerate Widget Code",
      "REGENERATE_CONFIRM_MESSAGE": "Are you sure you want to regenerate the widget code? The old code will stop working and you will need to update the snippet on your site.",
      "SNIPPET_COPIED": "Snippet copied to clipboard!"
    },
    "PROFILE": {
      "ERROR_SAVE": "Could not save profile."
    },
    "BUSINESS": {
      "ERROR_SAVE": "Could not save business details."
    },
    "SECURITY": {
      "PASSWORD_ERROR": "Could not update password."
    },
    "AI_AUTO_DISABLE": {
      "ERROR_LOAD": "Could not load AI auto-disable settings.",
      "ERROR_SAVE": "Could not save AI auto-disable settings."
    },
    "INTEGRATIONS": {
      "POPUP_BLOCKED": "Popup was blocked. Allow popups for this site to continue."
    },
    "WHATSAPP": {
      "DISCONNECT_ERROR": "Could not disconnect WhatsApp.",
      "REQUEST_ERROR": "Could not submit the WhatsApp request."
    }
  },

  "DASHBOARD": {
    "GOOD_MORNING": "Good morning",
    "GOOD_AFTERNOON": "Good afternoon",
    "GOOD_EVENING": "Good evening",
    "WELCOME_SUBTITLE": "Here's what's happening with your business today.",
    "QUICK_ACTIONS": "Quick actions",
    "KEY_METRICS": "Key metrics",
    "ACTIVITY": "Activity",
    "NEW_BOOKING": "New booking",
    "REPORTS": "Reports",
    "TODAYS_AGENDA": "Today's agenda",
    "SOON": "Soon",
    "LIVE_INBOX_TITLE": "Live Conversations",
    "VIEW_ALL": "View all ↗",
    "LIVE_INBOX_DESC": "Recent client messages awaiting response",
    "OPEN_CHAT": "Open Chat",
    "AI_SUMMARY": "AI Summary:",
    "INSIGHTS_TITLE": "Daily Insights",
    "MOST_ASKED_TODAY": "Most asked today:",
    "SUGGESTION": "Suggestion:",
    "DEFAULT_QUESTION": "How long does the recovery take?",
    "DEFAULT_SUGGESTION": "3 clients asked about aftercare. Consider adding a \"Quick Reply\" for peel treatments.",
    "DEFAULT_TREND": "Booking conversion up 5% vs last week"
  },

  "TENANT_MODAL": {
    "TITLE_CREATE": "Create New Tenant",
    "TITLE_EDIT": "Edit Tenant",
    "SUBTITLE": "Configure tenant settings and AI preferences.",
    "SECTION_BUSINESS_DETAILS": "Business Details",
    "SECTION_AI_SETTINGS": "AI Settings",
    "SECTION_AI_CONFIGURATION": "AI Configuration",
    "LABEL_AI_NAME": "AI NAME",
    "PLACEHOLDER_AI_NAME": "e.g. Support Bot",
    "LABEL_AI_PERSONALITY": "AI PERSONALITY & TONE",
    "PLACEHOLDER_AI_PERSONALITY": "You are a helpful and polite customer service assistant. You speak with a formal tone...",
    "LABEL_AI_LIMITS": "AI LIMITS & RULES",
    "PLACEHOLDER_AI_LIMITS": "Do not answer questions about politics. Do not provide medical advice. Max response length: 50 words...",
    "DESCRIPTION_AI_LIMITS": "Define strict boundaries and operational rules for the AI model.",
    "LABEL_BUSINESS_NAME": "BUSINESS NAME",
    "LABEL_EMAIL": "EMAIL",
    "PLACEHOLDER_EMAIL": "name@company.com",
    "LABEL_PHONE": "PHONE",
    "LABEL_VERTICAL": "VERTICAL",
    "LABEL_TIER": "TIER",
    "LABEL_LANGUAGE": "LANGUAGE",
    "LABEL_AI_CONFIGURATIONS": "AI CONFIGURATIONS",
    "LABEL_AI_TYPE": "AI TYPE",
    "LABEL_MODEL": "MODEL",
    "LABEL_API_KEY": "API KEY",
    "LABEL_API_KEY_UPDATE": "API KEY (leave empty to keep current)",
    "PLACEHOLDER_API_KEY": "Enter API key",
    "BUTTON_ADD_AI_CONFIG": "Add AI Configuration",
    "BUTTON_CANCEL": "Cancel",
    "BUTTON_CREATE": "Create Tenant",
    "BUTTON_UPDATE": "Update Tenant",
    "BUTTON_CREATING": "Creating...",
    "BUTTON_UPDATING": "Updating...",
    "ERROR_CREATING": "Error creating tenant",
    "ERROR_UPDATING": "Error updating tenant"
  },

  "CONTACTS": {
    "TITLE": "Contacts",
    "MANAGE_FIELDS": "Manage fields",
    "UPLOAD_CONTACT_LIST": "Upload contact list",
    "ADD_CONTACT": "Add a contact",
    "SEARCH_PLACEHOLDER": "Search contacts by name, email or phone...",
    "FILTER_BY": "Filter by:",
    "ALL_CONTACTS": "All Contacts",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "NO_CONTACTS_FOUND": "No contacts found",
    "SHOWING": "Showing",
    "OF": "of",
    "CONTACTS": "contacts",
    "DELETE_CONFIRM_TITLE": "Confirm deletion",
    "DELETE_CONFIRM": "Are you sure you want to delete this contact?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error loading contacts",
    "ERROR_DELETING": "Error deleting contact",
    "DELETE_SUCCESS": "Contact deleted successfully.",
    "PLATFORMS": {
      "WHATSAPP": "WhatsApp",
      "TELEGRAM": "Telegram",
      "EMAIL": "Email",
      "MANUAL": "Manual",
      "WEBCHAT": "Web chat"
    },
    "STATUS": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive"
    },
    "LAST_ACTIVE": {
      "LABEL": "Last Active",
      "JUST_NOW": "Just now",
      "MINUTES_AGO": "{{minutes}}m ago",
      "HOURS_AGO": "{{hours}}h ago",
      "DAYS_AGO": "{{days}}d ago",
      "WEEKS_AGO": "{{weeks}}w ago"
    },
    "MODAL": {
      "ADD_TITLE": "Add New Contact",
      "EDIT_TITLE": "Edit Contact",
      "ADD_SUBTITLE": "Create a new profile in your workspace.",
      "EDIT_SUBTITLE": "Update existing contact information.",
      "BASIC_INFO": "Basic Information",
      "FULL_NAME": "Full Name",
      "FULL_NAME_PLACEHOLDER": "e.g. Elena",
      "LAST_NAME": "Last Name",
      "LAST_NAME_PLACEHOLDER": "e.g. Rossi",
      "EMAIL_ADDRESS": "Email Address",
      "EMAIL_PLACEHOLDER": "name@example.com",
      "PHONE_NUMBER": "Phone Number",
      "PHONE_PLACEHOLDER": "+39 000 00000",
      "PREFERENCES": "Preferences",
      "FAVOURITE_CONTACT_METHOD": "Favourite contact method",
      "STATUS": "Status",
      "ACTIVE_STATUS_LABEL": "Active Status",
      "ACTIVE_STATUS_DESCRIPTION": "Is this contact reachable?",
      "CUSTOM_ATTRIBUTES": "Custom Attributes",
      "TAGS_LABELS": "Tags & Labels",
      "TAGS_ASSIGNED": "assigned",
      "TAGS_PLACEHOLDER": "Select tags...",
      "MORE_TAGS": "more +",
      "CANCEL": "Cancel",
      "CREATE_CONTACT": "Create Contact",
      "UPDATE_CONTACT": "Update Contact",
      "ERROR_CREATING": "Error creating contact",
      "ERROR_UPDATING": "Error updating contact",
      "YES": "Yes",
      "NO": "No",
      "ENTER_FIELD_PLACEHOLDER": "Enter {{label}}..."
    },
    "DETAIL": {
      "BACK": "Back",
      "PAGE_TITLE": "Contact details",
      "SUBTITLE": "View and edit contact information",
      "NOT_FOUND": "Contact not found.",
      "DELETE": "Delete",
      "SAVE_SUCCESS": "Contact updated successfully.",
      "SUMMARY": {
        "TITLE": "Contact AI summary",
        "EMPTY": "No summary available.",
        "GENERATE": "Generate summary",
        "REFRESH": "Refresh summary",
        "IN_PROGRESS": "Refresh in progress",
        "REFRESH_STARTED": "Summary generation started in background.",
        "REFRESH_ERROR": "Could not start summary generation.",
        "STATUS_NOT_STARTED": "Not started",
        "STATUS_IN_PROGRESS": "In progress",
        "STATUS_COMPLETE": "Complete",
        "STATUS_FAILED": "Failed",
        "STATUS_NEED_UPDATE": "Need update",
        "META_FIRST_COMPLETE": "First summary done",
        "META_LAST_COMPLETED": "Last summary completed",
        "META_LAST_REQUESTED": "Last refresh requested",
        "META_SOURCE_UPDATED": "Contact data last changed",
        "META_VERSION": "Summary version",
        "META_NOT_AVAILABLE": "—",
        "NEED_UPDATE_HINT": "Contact data changed after the last summary. Refresh the summary so the AI assistant uses up-to-date information."
      },
      "SUMMARY_CHAT": {
        "TITLE": "Contact AI assistant",
        "SUBTITLE": "Answers from contact KB (summary + appointments); summary is not regenerated",
        "READY": "Ready",
        "LOCKED": "Locked",
        "LOCK_HINT": "Generate the summary at least once to enable chat. Chat is disabled while a new summary is generating.",
        "HINT": "Ask a question — the AI uses only the saved summary, appointments, and attachment text (no summary regeneration).",
        "PLACEHOLDER": "Type a question…",
        "INPUT_LOCKED": "Chat is disabled until the summary is Complete.",
        "AI_EMPTY": "The AI returned an empty answer. Try again or refresh the summary.",
        "ERROR": "I could not answer right now. Please try again.",
        "RESPONDING": "Thinking…"
      },
      "CONVERSATIONS": "Conversations",
      "NO_CONVERSATIONS": "No conversations yet.",
      "NO_MESSAGES": "No messages",
      "APPOINTMENTS": "Appointments",
      "NO_APPOINTMENTS": "No appointments.",
      "FORMS": {
        "BUTTON": "Form",
        "EMPTY": "No form for this appointment.",
        "TYPE_REQUIRED": "Required",
        "TYPE_OPTIONAL": "Optional",
        "TYPE_UNKNOWN": "Type unavailable",
        "STATUS_SUBMITTED": "Submitted",
        "STATUS_PENDING": "Not submitted",
        "STATUS_EMPTY": "Unavailable",
        "PENDING_INFO": "The customer has not filled out this form yet."
      }
    },
    "APPOINTMENT_DETAIL": {
      "PAGE_TITLE": "Appointment",
      "SUBTITLE": "Notes and attachments for this appointment",
      "BACK_TO_CONTACT": "Back to contact",
      "NOT_FOUND": "Appointment not found.",
      "LOAD_ERROR": "Could not load appointment.",
      "BASIC": "Details",
      "SERVICE": "Service",
      "DATE": "Date",
      "TIME": "Time",
      "STATUS": "Status",
      "NOTES": "Notes",
      "NOTES_PLACEHOLDER": "Add notes for this appointment...",
      "SAVE_NOTES": "Save notes",
      "NOTES_SAVED": "Notes saved.",
      "NOTES_SAVE_ERROR": "Could not save notes.",
      "ATTACHMENTS": "Attachments",
      "ATTACHMENTS_HINT": "Drag files here or click to select. Allowed: PDF, Office documents, images, TXT.",
      "SELECT_FILES": "Choose files",
      "UPLOADING": "Uploading...",
      "UPLOAD_SUCCESS": "Files uploaded.",
      "UPLOAD_ERROR": "Upload failed.",
      "NO_ATTACHMENTS": "No attachments yet.",
      "COL_NAME": "File",
      "COL_TYPE": "Type",
      "COL_SIZE": "Size",
      "COL_UPLOADED": "Uploaded",
      "COL_USER": "User",
      "COL_ACTIONS": "Actions",
      "PREVIEW": "Preview",
      "DOWNLOAD": "Download",
      "DELETE": "Remove",
      "DELETE_CONFIRM_TITLE": "Remove attachment",
      "DELETE_CONFIRM": "Remove <strong>{{name}}</strong> from this appointment?",
      "DELETE_SUCCESS": "Attachment removed.",
      "DELETE_ERROR": "Could not remove attachment.",
      "DOWNLOAD_ERROR": "Could not download file.",
      "PREVIEW_ERROR": "Could not open file preview.",
      "EXTRACTION_PENDING": "Extracting…",
      "EXTRACTION_COMPLETED": "Text extracted",
      "EXTRACTION_SKIPPED": "Preview not available",
      "EXTRACTION_FAILED": "Extraction failed",
      "BYTES": "{{size}} B",
      "KB": "{{size}} KB",
      "MB": "{{size}} MB",
      "FORMS": {
        "TITLE": "Appointment form",
        "EMPTY": "No form for this appointment.",
        "TYPE_REQUIRED": "Required",
        "TYPE_OPTIONAL": "Optional",
        "TYPE_UNKNOWN": "Type unavailable",
        "STATUS_SUBMITTED": "Submitted",
        "STATUS_PENDING": "Not submitted",
        "STATUS_EMPTY": "Unavailable",
        "PENDING_INFO": "The customer has not filled out this form yet."
      }
    },
    "FIELDS_MANAGEMENT": {
      "TITLE": "Manage Fields",
      "SUBTITLE": "Configure contact labels and custom attributes",
      "TAGS_TAB": "Tags & Labels",
      "ONBOARDING_TAB": "Chatbot onboarding",
      "CUSTOM_FIELDS_TAB": "Custom Fields",
      "TAG_INPUT_PLACEHOLDER": "Enter new tag name...",
      "TAG_ALREADY_EXISTS": "Tag already exists",
      "TAG_CREATED": "Tag created successfully.",
      "LOADING_TAGS": "Loading tags...",
      "ERROR_LOADING_TAGS": "Error loading tags",
      "ERROR_CREATING_TAG": "Error creating tag",
      "ERROR_DELETING_TAG": "Error deleting tag",
      "DELETE_TAG_CONFIRM_TITLE": "Confirm deletion",
      "DELETE_TAG_CONFIRM_MESSAGE": "Are you sure you want to delete this tag?\n<strong>{{name}}</strong>",
      "CREATE_FIELD": "Create New Custom Field",
      "EDIT_FIELD": "Edit Field",
      "FIELD_NAME": "Field Name",
      "FIELD_NAME_PLACEHOLDER": "e.g. Birthday",
      "SLUG_ID": "Slug (ID)",
      "SLUG_PLACEHOLDER": "e.g. birthday",
      "FORMAT_TYPE": "Format Type",
      "TEXT": "Text",
      "NUM": "Num",
      "DATE": "Date",
      "BOOL": "Bool",
      "ADD_CUSTOM_FIELD": "Add Custom Field",
      "UPDATE_FIELD": "Update Field",
      "LOADING_FIELDS": "Loading custom fields...",
      "ERROR_LOADING_FIELDS": "Error loading custom fields",
      "ERROR_CREATING_FIELD": "Error creating custom field",
      "ERROR_UPDATING_FIELD": "Error updating custom field",
      "ERROR_DELETING_FIELD": "Error deleting custom field",
      "DELETE_FIELD_CONFIRM_TITLE": "Confirm deletion",
      "DELETE_FIELD_CONFIRM_MESSAGE": "Are you sure you want to delete this custom field?\n<strong>{{name}}</strong>",
      "QUESTION_EXAMPLE": "Question / Example",
      "QUESTION_EXAMPLE_PLACEHOLDER": "e.g. What is your birth date?",
      "ACTIVE": "Active",
      "REQUIRED": "Required",
      "REQUIRED_FOR_ONBOARDING": "Required for chatbot onboarding",
      "ONBOARDING_HINT": "If you enable “Required for chatbot onboarding”, the chatbot will ask this field before proceeding. The question used is the one in “Question / Example”.",
      "ONBOARDING_QUESTION": "Onboarding question",
      "ONBOARDING_QUESTION_EMPTY": "No custom question set",
      "ONBOARDING_TAB_SUBTITLE": "Manage the base details requested at chat start: first name, last name, phone, and email (email is optional).",
      "EDIT_ONBOARDING_FIELD": "Edit onboarding field",
      "FIELD_ENABLED": "Field enabled in data collection",
      "SAVE_ONBOARDING_FIELD": "Save onboarding field",
      "CLOSE_MANAGEMENT": "Close Management"
    },
    "FILTERS": {
      "ADVANCED_FILTERS": "Advanced Filters",
      "COMMUNICATION_PLATFORM": "Communication Platform",
      "CLIENT_LABELS": "Client Labels",
      "LAST_ACTIVE_PERIOD": "Last Active Period",
      "ALL_TIME": "All Time",
      "LAST_7_DAYS": "Last 7 Days",
      "LAST_30_DAYS": "Last 30 Days",
      "RESET_ALL": "Reset All",
      "APPLY": "Apply"
    }
  },

  "SERVICES": {
    "MANAGE_CATEGORIES": "Manage categories",
    "ADD_SERVICE": "Add Service",
    "SEARCH_PLACEHOLDER": "Search services by name or description...",
    "FILTER_BY": "Filter by:",
    "ALL": "All",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "FILTER_BY_CATEGORY": "Filter by category",
    "CLEAR": "Clear",
    "RESET_FILTERS": "Reset filters",
    "NO_SERVICES": "No services found",
    "PRICE": "Price",
    "DURATION": "Duration",
    "PREP": "Prep",
    "COOLDOWN": "Cooldown",
    "SHOWING": "Showing",
    "OF": "of",
    "SERVICES": "services",
    "DELETE_CONFIRM_TITLE": "Confirm deletion",
    "DELETE_CONFIRM": "Are you sure you want to delete this service?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error loading services",
    "ERROR_DELETING": "Error deleting service",
    "FORMS": {
      "ADD_FORM": "Add form",
      "MANAGE_FORMS": "Manage forms",
      "MANAGE_TITLE": "Forms management",
      "MANAGE_SUBTITLE": "View, edit or delete booking forms.",
      "NO_FORMS": "You haven't created any form yet.",
      "TEST_FORM": "Test form",
      "ADD_TITLE": "Create new form",
      "EDIT_TITLE": "Edit form",
      "ADD_SUBTITLE": "Configure structure and questions for the new form.",
      "EDIT_SUBTITLE": "Update form title, description and questions.",
      "METADATA_TITLE": "Form settings",
      "NAME": "Form name",
      "NAME_PLACEHOLDER": "e.g. Pre-visit questionnaire",
      "DESCRIPTION": "Description (optional)",
      "DESCRIPTION_PLACEHOLDER": "Briefly explain what this form is for...",
      "QUESTIONS_TITLE": "Form questions",
      "ADD_QUESTION": "Add question",
      "QUESTION_TEXT": "Question text",
      "QUESTION_TEXT_PLACEHOLDER": "e.g. Do you have any known allergies?",
      "QUESTION_DESCRIPTION": "Question description (optional)",
      "QUESTION_DESCRIPTION_PLACEHOLDER": "Add details or instructions for this question...",
      "QUESTION_TYPE": "Answer type",
      "QUESTION_REQUIRED": "Required answer",
      "OPTIONS_TITLE": "Answer options",
      "ADD_OPTION": "Add option",
      "OPTION_LABEL": "Option",
      "OPTION_PLACEHOLDER": "e.g. Yes",
      "TYPE_TEXT": "Short answer",
      "TYPE_MULTILINE": "Paragraph",
      "TYPE_SINGLE_CHOICE": "Single choice",
      "TYPE_MULTIPLE_CHOICE": "Multiple choice",
      "TYPE_NUMBER": "Number",
      "TYPE_DATE": "Date",
      "BOOKING_FORM_TITLE": "Booking form",
      "SELECT_FORM": "Select a form to attach",
      "NO_FORM": "No form",
      "REQUIRED_FOR_BOOKING": "Form required to confirm booking",
      "PRIVACY_POLICY_ENABLE": "Enable Privacy & Policy form",
      "PRIVACY_POLICY_TEXT_LABEL": "Privacy & Policy text",
      "PRIVACY_POLICY_TEXT_PLACEHOLDER": "Enter the full privacy policy text",
      "PRIVACY_POLICY_LINK_LABEL": "Privacy & Policy link",
      "PRIVACY_POLICY_LINK_PLACEHOLDER": "https://...",
      "SAVE": "Save form",
      "UPDATE": "Update form",
      "ERROR_LOADING_FORMS": "Error loading forms",
      "DELETE_CONFIRM_TITLE": "Delete form",
      "DELETE_CONFIRM": "Are you sure you want to delete this form?\n<strong>{{name}}</strong>",
      "ERROR_DELETING_FORM": "Error deleting form",
      "ERROR_CREATING_TEST_LINK": "Error creating test link for this form",
      "TEST_LINK_OPENED": "Test link opened in a new tab.",
      "ERROR_SAVING_FORM": "Error saving form",
      "ERROR_UPDATING_FORM": "Error updating form"
    },
    "MODAL": {
      "ADD_TITLE": "Add New Service",
      "EDIT_TITLE": "Edit Service",
      "ADD_SUBTITLE": "Create a new service for your catalog.",
      "EDIT_SUBTITLE": "Update service information.",
      "DETAILS": "Service details",
      "NAME": "Service name",
      "NAME_PLACEHOLDER": "e.g. Chemical Peel",
      "DESCRIPTION": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe the treatment and its benefits...",
      "CATEGORIES": "Categories",
      "CATEGORIES_PLACEHOLDER": "Select categories...",
      "MORE_CATEGORIES": "more +",
      "PRICE_AND_DURATION": "Price and duration",
      "PRICE": "Price (€)",
      "PRICE_PLACEHOLDER": "e.g. 120",
      "DURATION": "Duration (min)",
      "DURATION_PLACEHOLDER": "e.g. 45",
      "PREP_TIME": "Preparation time (min)",
      "PREP_PLACEHOLDER": "0",
      "COOLDOWN_TIME": "Cooldown time (min)",
      "COOLDOWN_PLACEHOLDER": "0",
      "BUFFER_TIMES_TITLE": "Dynamic Buffer Times",
      "BUFFER_TIMES_DESC": "Define extra time to be automatically blocked in your calendar for setup and post-treatment care.",
      "ACTIVE_STATUS_LABEL": "Active status",
      "ACTIVE_STATUS_DESCRIPTION": "When active, this service is available for booking.",
      "STATUS": "Status",
      "CANCEL": "Cancel",
      "CREATE": "Create Service",
      "UPDATE": "Update Service",
      "ERROR_CREATING": "Error creating service",
      "ERROR_UPDATING": "Error updating service"
    },
    "CATEGORIES": {
      "TITLE": "Manage service categories",
      "SUBTITLE": "Create and remove categories used to classify services.",
      "INPUT_PLACEHOLDER": "Enter new category name...",
      "LOADING": "Loading categories...",
      "ALREADY_EXISTS": "This category already exists",
      "ERROR_LOADING": "Error loading categories",
      "ERROR_CREATING": "Error creating category",
      "ERROR_DELETING": "Error deleting category",
      "DELETE_CONFIRM_TITLE": "Confirm deletion",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to delete this category?\n<strong>{{name}}</strong>"
    }
  },

  "COLLABORATORS": {
    "ADD": "Add Collaborator",
    "SEARCH_PLACEHOLDER": "Search collaborators by name or service...",
    "FILTER_BY": "Filter by:",
    "FILTER_BY_SERVICES": "Filter by Assigned Services",
    "ALL": "All",
    "AVAILABLE": "Available",
    "NOT_AVAILABLE": "Not Available",
    "SHOWING": "Showing",
    "OF": "of",
    "COLLABORATORS_COUNT": "collaborators",
    "NO_COLLABORATORS": "No collaborators found",
    "NO_COLLABORATORS_DESC": "Try adjusting your filters or search query.",
    "DELETE_CONFIRM_TITLE": "Confirm deletion",
    "DELETE_CONFIRM": "Are you sure you want to delete this collaborator?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error loading collaborators",
    "ERROR_DELETING": "Error deleting collaborator",
    "ERROR_SAVE": "Error saving collaborator",
    "MODAL": {
      "ADD_TITLE": "Add New Collaborator",
      "EDIT_TITLE": "Edit Collaborator",
      "ADD_SUBTITLE": "Create a new collaborator and set their schedule and services.",
      "EDIT_SUBTITLE": "Update collaborator details, schedule, and assigned services.",
      "PROFILE": "Collaborator Profile",
      "PROFILE_DESC": "Configure staff details, working hours, and assigned services.",
      "FIRST_NAME": "First Name",
      "FIRST_NAME_PLACEHOLDER": "e.g. Elena",
      "LAST_NAME": "Last Name",
      "LAST_NAME_PLACEHOLDER": "e.g. Rossi",
      "EMAIL": "Email address",
      "EMAIL_PLACEHOLDER": "elena.rossi@company.com",
      "PHONE": "Phone Number",
      "PHONE_PLACEHOLDER": "+39 333 123 4567",
      "ADDRESS": "Address",
      "ADDRESS_DESC": "Location where this collaborator works for in-person services.",
      "REMOTE": "Remote",
      "REMOTE_DESCRIPTION": "When enabled, services are delivered remotely (e.g. video call); address does not apply.",
      "ADDRESS_STREET": "Street",
      "ADDRESS_STREET_PLACEHOLDER": "e.g. 10 Main Street",
      "ADDRESS_CITY": "City",
      "ADDRESS_CITY_PLACEHOLDER": "e.g. Milan",
      "ADDRESS_PROVINCE": "Province / State",
      "ADDRESS_PROVINCE_PLACEHOLDER": "e.g. MI",
      "ADDRESS_POSTAL_CODE": "Postal code",
      "ADDRESS_POSTAL_CODE_PLACEHOLDER": "e.g. 20100",
      "ADDRESS_COUNTRY": "Country",
      "ADDRESS_COUNTRY_PLACEHOLDER": "e.g. Italy",
      "ASSIGNED_SERVICES": "Assigned Services",
      "ASSIGNED_SERVICES_PLACEHOLDER": "Select services to assign...",
      "STATUS": "Availability Status",
      "STATUS_DESCRIPTION": "When available, this collaborator can be assigned to bookings.",
      "SAVE": "Save Collaborator",
      "UPDATE": "Update Collaborator"
    },
    "WEEKDAYS": {
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "SUNDAY": "Sunday"
    },
    "WORKING_HOURS": {
      "LABEL": "Working Hours",
      "DESC": "Define when this collaborator is available for bookings.",
      "EDIT": "Edit Opening Hours",
      "ADD": "Add Opening Hours",
      "TITLE": "Set Working Hours",
      "SUBTITLE": "Define weekly schedule and breaks.",
      "QUICK_APPLY": "Quick apply:",
      "EVERY_DAY": "Every day",
      "WEEKDAYS": "Weekdays (Mon–Fri)",
      "WEEKENDS": "Weekends (Sat–Sun)",
      "ADD_RANGE": "Add range",
      "CLOSED": "Closed",
      "SAVE_HOURS": "Save Hours",
      "INVALID_RANGE": "Invalid range for {{day}}: Start time must be before end time.",
      "OVERLAP": "Overlapping ranges detected for {{day}}.",
      "DISCARD_CONFIRM": "Discard changes?",
      "SUMMARY_MON_FRI": "Mon–Fri",
      "SUMMARY_EVERY_DAY": "Every day",
      "SUMMARY_DAYS": "{{count}} days / week"
    }
  },

  "KNOWLEDGE_BASE": {
    "TITLE": "Knowledge Base",
    "TAB_FAQS": "FAQs",
    "TAB_LINKS": "External Links",
    "DELETE_FAQ_CONFIRM_TITLE": "Confirm deletion",
    "DELETE_FAQ_CONFIRM_MESSAGE": "Are you sure you want to delete this FAQ?\n<strong>{{question}}</strong>",
    "DELETE_LINK_CONFIRM_TITLE": "Confirm deletion",
    "DELETE_LINK_CONFIRM_MESSAGE": "Are you sure you want to delete this link?\n<strong>{{title}}</strong>",
    "SEARCH_FAQS": "Search FAQs...",
    "SEARCH_LINKS": "Search links...",
    "ADD_FAQ": "Add FAQ",
    "ADD_LINK": "Add Link",
    "EMPTY_FAQS_TITLE": "No FAQs found",
    "EMPTY_FAQS_DESC": "No questions match your search. Try adding a new one or adjusting your keywords.",
    "EMPTY_LINKS_TITLE": "No links found",
    "EMPTY_LINKS_DESC": "Start building your knowledge base by adding external resource links.",
    "MODAL": {
      "TITLE_ADD_FAQ": "Add New FAQ",
      "TITLE_EDIT_FAQ": "Edit FAQ",
      "TITLE_ADD_LINK": "Add New Link",
      "TITLE_EDIT_LINK": "Edit Link",
      "FAQ_SUBTITLE": "Teach the AI a specific business answer.",
      "LINK_SUBTITLE": "Provide an external resource for the AI to reference.",
      "FAQ_DETAILS": "FAQ Details",
      "LINK_INFO": "Link Information",
      "QUESTION": "Question",
      "QUESTION_PLACEHOLDER": "e.g. What are your opening hours?",
      "ANSWER": "Answer",
      "ANSWER_PLACEHOLDER": "Provide the detailed answer for the AI...",
      "TITLE": "Title",
      "TITLE_PLACEHOLDER": "e.g. Pricing PDF 2024",
      "URL": "URL",
      "URL_PLACEHOLDER": "https://example.com",
      "SHORT_DESCRIPTION": "Short Description",
      "SHORT_DESCRIPTION_PLACEHOLDER": "Explain to the AI what this link contains...",
      "CANCEL": "Cancel",
      "SAVE_CHANGES": "Save Changes",
      "ADD_FAQ": "Add FAQ",
      "ADD_LINK": "Add Link",
      "ERROR_SAVE": "Could not save. Please try again."
    },
    "ERROR_LOADING_FAQ": "Error loading FAQs",
    "ERROR_LOADING_LINKS": "Error loading links",
    "ERROR_DELETE_FAQ": "Error deleting FAQ",
    "ERROR_DELETE_LINK": "Error deleting link"
  },

  "ERRORS": {
    "AUTH_INVALID_CREDENTIALS": "Invalid email or password",
    "AUTH_TOKEN_EXPIRED": "Your session has expired, please login again",
    "AUTH_UNAUTHORIZED": "You are not authorized to access this resource",
    "AUTH_EMAIL_ALREADY_EXISTS": "An account with this email already exists",
    "AUTH_FORBIDDEN": "You do not have permission to perform this action",

    "TENANT_NOT_FOUND": "Tenant not found",
    "TENANT_ALREADY_EXISTS": "A tenant with this name already exists",
    "TENANT_NAME_TAKEN": "This tenant name is already taken",
    "TENANT_CREATION_FAILED": "Failed to create tenant",
    "TENANT_UPDATE_FORBIDDEN": "Only super admin can update tenants",
    "TENANT_DELETE_FORBIDDEN": "Only super admin can delete tenants",
    "TENANT_ACCESS_DENIED": "Access denied to this tenant",
    "TENANT_INVITE_FORBIDDEN": "Only super admin or tenant admin can invite users",

    "USER_NOT_FOUND": "User not found",
    "USER_EMAIL_INVALID": "Invalid email address",
    "USER_ROLE_INVALID": "Invalid user role",
    "USER_UPDATE_FORBIDDEN": "You cannot update this user",
    "USER_ASSIGN_FORBIDDEN": "Only super admin can assign users to tenants",
    "USER_REMOVE_FORBIDDEN": "Only super admin can remove users from tenants",

    "INVITE_NOT_FOUND": "Invitation not found",
    "INVITE_EXPIRED": "This invitation has expired",
    "INVITE_ALREADY_USED": "This invitation has already been used",
    "INVITE_CREATION_FAILED": "Failed to create invitation",
    "INVITE_EMAIL_SEND_FAILED": "Failed to send the invitation email. The invitation was rolled back. Check your Resend API key, template IDs, and sender configuration.",

    "CONTACT_NOT_FOUND": "Contact not found",
    "CONTACT_ACCESS_DENIED": "Access denied to this contact",
    "CONTACT_CREATION_FORBIDDEN": "Only admin or super_admin can create contacts",
    "CONTACT_UPDATE_FORBIDDEN": "Only admin or super_admin can update contacts",
    "CONTACT_DELETE_FORBIDDEN": "Only admin or super_admin can delete contacts",
    "CONTACT_DUPLICATE_EMAIL": "A contact with this email already exists in your tenant",

    "VALIDATION_REQUIRED_FIELD": "This field is required",
    "VALIDATION_INVALID_EMAIL": "Invalid email format",
    "VALIDATION_MIN_LENGTH": "Value is too short",
    "VALIDATION_MAX_LENGTH": "Value is too long",

    "SYSTEM_INTERNAL_ERROR": "An unexpected error occurred",
    "SYS_001": "Unknown error",
    "SYSTEM_DATABASE_ERROR": "Database operation failed",
    "NETWORK_ERROR": "Network connection error"
  },

  "ERROR_MODAL": {
    "TITLE": "Error",
    "HEADING": "Something went wrong",
    "STATUS": "Status",
    "ERROR_CODE": "Error code",
    "MESSAGE": "Message",
    "PATH": "Path",
    "TIMESTAMP": "Timestamp",
    "DETAILS": "Details",
    "TECHNICAL_DETAILS": "Technical details",
    "NO_MESSAGE": "No message",
    "CLOSE": "Close"
  },

  "SUCCESS": {
    "TENANT_CREATED": "Tenant created successfully",
    "TENANT_UPDATED": "Tenant updated successfully",
    "TENANT_DELETED": "Tenant deleted successfully",
    "USER_INVITED": "Invitation sent successfully",
    "USER_UPDATED": "User updated successfully",
    "USER_ASSIGNED": "User assigned to tenant successfully",
    "USER_REMOVED": "User removed from tenant successfully",
    "INVITE_ACCEPTED": "Invitation accepted successfully"
  },

  "INVITE_ACCEPT": {
    "TITLE": "Accept Invitation",
    "SUBTITLE_LOADING": "Completing registration...",
    "SUBTITLE_VALID": "Complete your profile to join the tenant",
    "SUBTITLE_INVALID": "Enter the invitation link you received by email",
    "VALIDATING": "Validating invitation...",
    "INVITED_BY": "You have been invited by",
    "THIS_TENANT": "this tenant",
    "EMAIL": "Email",
    "ROLE": "Role",
    "FIRST_NAME": "First name",
    "LAST_NAME": "Last name",
    "PASSWORD": "Password",
    "CONFIRM_PASSWORD": "Confirm password",
    "PHONE_OPTIONAL": "Phone (optional)",
    "PASSWORD_MISMATCH": "Passwords do not match.",
    "ACCEPTING": "Accepting...",
    "ACCEPT_BUTTON": "Accept Invitation",
    "SUCCESS_REDIRECT": "Invitation accepted successfully! Redirecting to dashboard...",
    "BACK_TO_LOGIN": "Back to login",
    "INVALID_TOKEN": "Invalid invitation token",
    "INVITE_INVALID_OR_EXPIRED": "Invitation invalid or expired",
    "VALIDATION_ERROR": "Error validating invitation",
    "ACCEPT_ERROR": "Error accepting invitation",
    "ACCOUNT_CREATE_ERROR": "Error creating account",
    "LOAD_USER_ERROR": "Account created but we couldn't load your profile. Please try logging in."
  },

  "FIREBASE_AUTH": {
    "EMAIL_ALREADY_IN_USE": "This email is already in use",
    "WEAK_PASSWORD": "Password should be at least 6 characters",
    "INVALID_EMAIL": "Invalid email address",
    "TOO_MANY_ATTEMPTS": "Too many attempts. Please try again later",
    "OPERATION_NOT_ALLOWED": "This sign-in method is not enabled",
    "USER_DISABLED": "This account has been disabled",
    "GENERIC": "Authentication error. Please try again",
    "INVALID_CREDENTIAL": "Invalid email or password",
    "NETWORK_ERROR": "Network error. Check your connection and try again",
    "POPUP_CLOSED": "Sign-in was cancelled",
    "ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL": "An account already exists with the same email but different sign-in method",
    "REQUIRES_RECENT_LOGIN": "Please sign out and sign in again to continue",
    "EXPIRED_ACTION_CODE": "This link has expired",
    "INVALID_ACTION_CODE": "This link is invalid or has already been used",
    "EMAIL_CHANGE_NEEDS_VERIFICATION": "Please verify your new email address",
    "UNKNOWN_ERROR": "Unknown error. Please try again"
  },
  "AGENDA": {
    "WEEKDAYS_SHORT": {
      "SUNDAY": "Sun",
      "MONDAY": "Mon",
      "TUESDAY": "Tue",
      "WEDNESDAY": "Wed",
      "THURSDAY": "Thu",
      "FRIDAY": "Fri",
      "SATURDAY": "Sat"
    },
    "WEEKDAY_LETTERS": "M,T,W,T,F,S,S",
    "MONTHS": {
      "JANUARY": "January",
      "FEBRUARY": "February",
      "MARCH": "March",
      "APRIL": "April",
      "MAY": "May",
      "JUNE": "June",
      "JULY": "July",
      "AUGUST": "August",
      "SEPTEMBER": "September",
      "OCTOBER": "October",
      "NOVEMBER": "November",
      "DECEMBER": "December"
    },
    "NO_AVAILABLE_SLOTS": "No available slots",
    "SLOT_BOOKED": "Already booked",
    "NEW_APPOINTMENT": "New Appointment",
    "SEARCH_PLACEHOLDER": "Search by title, client or notes...",
    "FILTER_BY": "Filter by:",
    "ALL": "All",
    "CONFIRMED": "Confirmed",
    "PENDING": "Pending",
    "COMPLETED": "Completed",
    "CANCELLED": "Cancelled",
    "CANCELLED_BY_CLIENT": "Cancelled by client",
    "LIST": "List",
    "CALENDAR": "Calendar",
    "TODAY": "Today",
    "VIEW_DAY": "Day",
    "VIEW_WEEK": "Week",
    "VIEW_MONTH": "Month",
    "ADVANCED_FILTERS": "Advanced filters",
    "DATE_FROM": "Date from",
    "DATE_TO": "Date to",
    "SERVICE": "Service",
    "CLIENT": "Client",
    "ALL_SERVICES": "All services",
    "ALL_CLIENTS": "All clients",
    "RESET_FILTERS": "Reset filters",
    "APPLY_FILTERS": "Apply filters",
    "NO_APPOINTMENTS": "No appointments found matching this filter.",
    "EDIT": "Edit",
    "COMPLETE": "Complete",
    "NO_SHOW": "No-show",
    "CANCELLED_BY_CLIENT_LABEL": "Cancelled by client",
    "NO_SHOW_LABEL": "No-show",
    "NO_SHOW_CONFIRM_TITLE": "Mark as no-show",
    "NO_SHOW_CONFIRM_MESSAGE": "Mark this appointment as no-show? The client did not attend.",
    "NO_SHOW_CONFIRM_YES": "Mark no-show",
    "CANCEL": "Cancel",
    "CONFIRM": "Confirm",
    "ERROR_LOADING": "Error loading appointments",
    "DELETE_CONFIRM_TITLE": "Delete appointment",
    "DELETE_CONFIRM_MESSAGE": "Are you sure you want to delete this appointment? This cannot be undone.",
    "DELETE_CONFIRM_YES": "Delete",
    "ERROR_UPDATE": "Error updating appointment",
    "ERROR_SAVE": "Error saving appointment",
    "CANCEL_CONFIRM_TITLE": "Cancel appointment",
    "CANCEL_CONFIRM_MESSAGE": "Are you sure you want to cancel this appointment?",
    "CANCEL_CONFIRM_YES": "Yes, cancel",
    "MODAL": {
      "ADD_TITLE": "New Appointment",
      "EDIT_TITLE": "Edit Appointment",
      "ADD_SUBTITLE": "Schedule a new appointment",
      "EDIT_SUBTITLE": "Update appointment details",
      "SERVICE": "Service",
      "SELECT_SERVICE": "Select a service",
      "SEARCH_SERVICE": "Search service...",
      "NO_SERVICES": "No services found",
      "TITLE": "Title",
      "TITLE_PLACEHOLDER": "e.g. Haircut & Style",
      "CLIENT": "Client",
      "SELECT_CLIENT": "Select a client",
      "SEARCH_CLIENT": "Search client...",
      "NO_CLIENTS": "No clients found",
      "COLLABORATOR": "Collaborator (optional)",
      "SELECT_COLLABORATOR": "Select a collaborator",
      "SEARCH_COLLABORATOR": "Search collaborator...",
      "NO_COLLABORATORS": "No collaborators found",
      "STATUS": "Status",
      "DATE": "Date",
      "START_TIME": "Start time",
      "END_TIME": "End time",
      "NOTES": "Notes (optional)",
      "NOTES_PLACEHOLDER": "Add any internal notes...",
      "SAVE": "Save Changes",
      "CREATE": "Create Appointment"
    },
    "STATUS": {
      "CONFIRMED": "Confirmed",
      "PENDING": "Pending",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled",
      "CANCELLED_BY_CLIENT": "Cancelled by client",
      "NO_SHOW": "No-show"
    },
    "COMPLETED_LABEL": "Completed",
    "FORMS": {
      "BOOKING_FORM": "Booking form",
      "RESPONSES_TITLE": "Form responses",
      "RESPONSES_SUBTITLE": "View the submitted answers for this appointment",
      "LINK_TITLE": "Public form link",
      "COPY_LINK": "Copy link",
      "NO_SUBMISSION": "No form has been generated yet for this appointment.",
      "STATUS_PENDING": "Form not yet completed",
      "STATUS_SUBMITTED": "Form completed",
      "ANSWERS_TITLE": "Submitted answers",
      "PRIVACY_TITLE": "Privacy & Policy",
      "PRIVACY_ACCEPTED_AT": "Accepted on",
      "NO_ANSWER": "No answer provided",
      "VIEW_RESPONSES": "View responses",
      "NO_FORM_FOR_APPOINTMENT": "No booking form is associated with this appointment.",
      "ERROR_LOADING_FORM": "Error loading form",
      "ERROR_LOADING_SUBMISSION": "Error loading form submission",
      "ERROR_NO_APPOINTMENT": "Select an appointment with a booking form to view responses."
    }
  },

  "FORMS": {
    "PUBLIC": {
      "NOT_FOUND": "The form was not found or the link is invalid.",
      "ALREADY_SUBMITTED": "You have already submitted this form. Thank you!",
      "ANSWER_PLACEHOLDER": "Type your answer...",
      "SUBMIT": "Submit form",
      "NEXT": "Next",
      "BACK": "Go back",
      "STEP_1_LABEL": "Details & requests",
      "STEP_2_LABEL": "Choose time",
      "PRIVACY_STEP_LABEL": "Privacy & Policy",
      "PRIVACY_ACCEPT_LABEL": "I have read and accept the Privacy & Policy",
      "SUBMITTED_ANSWERS": "Submitted answers",
      "SUMMARY_TITLE": "Summary of your request",
      "YOUR_ANSWERS": "Your answers",
      "YOUR_BOOKING": "Your booking",
      "CANCEL_BOOKING": "Cancel booking",
      "BOOKING_CANCELLED_SUCCESS": "Booking cancelled successfully",
      "BOOKING_CANCELLED_ERROR": "Could not cancel booking",
      "BOOKING_DATE": "Date",
      "BOOKING_TIME": "Time",
      "BOOKING_SERVICE": "Service",
      "BOOKING_WITH": "With",
      "BOOKING_DURATION": "Duration",
      "BOOKING_CONTEXT_TITLE": "Booking details",
      "BOOKING_CONTEXT_REGION": "Service and professional summary",
      "BOOKING_CONFIRM_TITLE": "Confirm booking",
      "CALENDAR_LOADING": "Loading time slots...",
      "BOOKING_SUCCESS_TITLE": "Booking confirmed.",
      "BOOKING_SUCCESS_MESSAGE": "You can close this page. A summary message has been sent in chat.",
      "PREFILLED_SLOT_NOTICE": "Slot fixed by the operator: {{date}} {{startTime}}–{{endTime}}",
      "BOOK_CTA": "Book",
      "CONFIRM_CTA": "Confirm",
      "CONFIRMING": "Confirming...",
      "BOOKING_NOTE_LABEL": "Notes (optional)",
      "BOOKING_NOTE_PLACEHOLDER": "Add any notes for the appointment",
      "DURATION_FMT_MINUTES": "{{m}} minutes",
      "DURATION_FMT_ONE_HOUR": "1 hour",
      "DURATION_FMT_HOURS": "{{h}} hours",
      "DURATION_FMT_ONE_HOUR_AND_MINUTES": "1 hour and {{m}} minutes",
      "DURATION_FMT_HOURS_AND_MINUTES": "{{h}} hours and {{m}} minutes",
      "ERROR_LOADING": "Error loading form",
      "ERROR_SUBMITTING": "Error submitting form",
      "REQUIRED_FIELD": "This field is required",
      "INVALID_TOKEN": "This form link is invalid or has expired.",
      "SUBMIT_SUCCESS": "Thank you! Your form was submitted successfully.",
      "ERROR_LOADING_SLOTS": "Could not load available time slots.",
      "ERROR_BOOKING": "Could not complete the booking. Please try again."
    }
  },

  "WIDGET_DEMO": {
    "TITLE": "Widget Chat Demo",
    "DESCRIPTION": "This is a sample page to test the chat widget. The widget appears in the bottom right corner.",
    "DEMO_PAGE_TITLE": "Demo Page",
    "DEMO_PAGE_DESCRIPTION": "This page simulates a website with the widget integrated. You can interact with the chatbot by clicking the icon in the bottom right corner.",
    "ERROR_NO_CODE": "No widget code available. Generate a widget code from Settings.",
    "ERROR_NOT_GENERATED": "Widget code not generated. Generate a widget code from Settings.",
    "ERROR_LOADING": "Error loading widget. Verify that the widget file is available.",
    "SUCCESS_LOADED": "Widget loaded successfully!",
    "SUCCESS_MESSAGE": "Click the icon in the bottom right corner to open the chat and test the widget.",
    "LOADING": "Loading widget...",
    "HOW_TO_TEST": "How to test:",
    "STEP_1": "Click the widget icon in the bottom right corner",
    "STEP_2": "The chat window will open",
    "STEP_3": "Write a message to test the conversation",
    "STEP_4": "Verify that the chatbot responses work correctly",
    "NOTE": "Note: This is a demo page. To integrate the widget on your site, copy the HTML snippet from Settings → Integrations.",
    "GO_TO_SETTINGS": "Go to Settings"
  },

  "WIDGET_TEST": {
    "TITLE": "Widget Integration Test",
    "DESCRIPTION": "Enter a widget code to test the chatbot integration on your site.",
    "CONFIGURATION_TITLE": "Widget Configuration",
    "CONFIGURATION_DESCRIPTION": "Enter the widget code to validate it and load the test widget",
    "WIDGET_CODE_LABEL": "Widget Code",
    "WIDGET_CODE_PLACEHOLDER": "Enter widget code (e.g. ABC123XYZ)",
    "WIDGET_CODE_REQUIRED": "Widget code is required",
    "LOADING": "Loading...",
    "LOAD_WIDGET": "Load Widget",
    "ERROR_PREFIX": "Error:",
    "VALID_WIDGET": "Valid widget!",
    "TENANT": "Tenant",
    "SNIPPET_TITLE": "HTML Snippet",
    "SNIPPET_DESCRIPTION": "Copy this snippet and paste it into your website to integrate the widget",
    "COPY_SNIPPET": "Copy Snippet",
    "HOW_TO_TITLE": "How to use the widget",
    "HOW_TO_STEP_1": "Generate or obtain your widget code from the Settings section",
    "HOW_TO_STEP_2": "Paste the HTML snippet in the <code>&lt;head&gt;</code> section or before closing <code>&lt;/body&gt;</code> on your site",
    "HOW_TO_STEP_3": "The widget will automatically appear as an icon in the bottom right corner",
    "HOW_TO_STEP_4": "Users can click the icon to open the chat",
    "NOTE_PREFIX": "Note:",
    "NOTE_TEXT": "The widget is dynamically loaded on this page for testing. Make sure the widget JS URL is publicly accessible when you integrate it on your site.",
    "ERROR_SUSPENDED": "This widget has been suspended.",
    "ERROR_BLOCKED": "This widget has been blocked.",
    "ERROR_INVALID": "Invalid or unknown widget code.",
    "ERROR_LOAD": "Could not load the widget. Check the code and try again.",
    "ERROR_SCRIPT": "Could not load the widget script. Check that the file is available."
  },

  "WIDGET": {
    "CHAT_TITLE": "Chat",
    "INPUT_PLACEHOLDER": "Type your message...",
    "SEND_BUTTON": "Send",
    "CLOSE_BUTTON": "Close chat",
    "OPEN_CHAT": "Open chat",
    "TYPING": "Typing...",
    "ERROR_SENDING": "Sorry, I encountered an error. Please try again.",
    "ERROR_VALIDATION": "Invalid widget code or tenant not active"
  },

  "CONVERSATIONS": {
    "SEARCH_PLACEHOLDER": "Search messages, clients or tags...",
    "FILTER_BY": "Filter by:",
    "FILTERS": {
      "ALL": "All",
      "UNREAD": "Unread",
      "PENDING": "Pending",
      "RESOLVED": "Resolved"
    },
    "CLIENT_PROFILE": {
      "TITLE": "Client Profile",
      "SEE_CONTACT": "See contact",
      "FULL_NAME": "Full Name",
      "EMAIL_ADDRESS": "Email Address",
      "PHONE_NUMBER": "Phone Number",
      "TAGS": "Tags",
      "SELECT_CONVERSATION": "Select a conversation to view client details."
    },
    "AI_SUMMARY": {
      "TITLE": "Conversation AI Summary",
      "NO_SUMMARY": "No summary available for this conversation yet."
    },
    "CHAT": {
      "SELECT_CONVERSATION": "Select a conversation from the left to start chatting.",
      "LAST_VISIT": "Last visit",
      "AI_MODE": "AI Mode",
      "AI_MODE_ACTIVE_NOTICE": "AI Mode is active. The chatbot will respond automatically to incoming messages.",
      "REPLY_PLACEHOLDER": "Type your reply… (Enter to send, Shift+Enter for new line)",
      "SENDING": "Sending..."
    },
    "CHANNELS": {
      "TELEGRAM": "Telegram",
      "WHATSAPP": "WhatsApp",
      "WEBCHAT": "Web Chat"
    },
    "ERROR_LOAD_LIST": "Could not load conversations.",
    "ERROR_LOAD_DETAILS": "Could not load this conversation.",
    "ERROR_SEND_MESSAGE": "Could not send the message.",
    "ERROR_AI_MODE": "Could not update AI mode."
  },
  "FLOWS": {
    "ADD_FLOW": "Add Flow",
    "NO_FLOWS": "No flows configured yet.",
    "UNNAMED": "Untitled Flow",
    "SHOWING": "Showing",
    "FLOWS_LABEL": "flows",
    "ERROR_LOADING": "Could not load flows.",
    "ERROR_CREATE": "Could not create flow.",
    "ERROR_UPDATE": "Could not update flow.",
    "ERROR_DELETE": "Could not delete flow.",
    "ERROR_STATUS": "Could not update flow status.",
    "ERROR_TEST": "Could not send test.",
    "ERROR_LOADING_EXECUTIONS": "Could not load flow executions.",
    "CREATED": "Flow created successfully.",
    "UPDATED": "Flow updated successfully.",
    "DELETED": "Flow deleted successfully.",
    "DELETE_CONFIRM_TITLE": "Delete flow",
    "DELETE_CONFIRM": "Are you sure you want to delete this flow?\n<strong>{{name}}</strong>",
    "STATUS_UPDATED": "Flow status updated.",
    "TEST_SENT": "Test messages sent successfully.",
    "COLUMNS": {
      "NAME": "Name",
      "TRIGGER": "Trigger",
      "TIMING": "Timing",
      "STATUS": "Status"
    },
    "TRIGGERS": {
      "APPOINTMENT_REQUESTED": "Appointment requested",
      "APPOINTMENT_CONFIRMED": "Appointment confirmed",
      "APPOINTMENT_UPDATED": "Appointment updated",
      "APPOINTMENT_CANCELLED": "Appointment cancelled",
      "APPOINTMENT_CANCELLED_BY_CLIENT": "Appointment cancelled by client",
      "APPOINTMENT_COMPLETED": "Appointment completed",
      "APPOINTMENT_NO_SHOW": "Appointment no-show",
      "APPOINTMENT_REMINDER": "Appointment reminder (slot)",
      "CONVERSATION_NO_RESPONSE": "No reply after outbound message",
      "FORM_NOT_COMPLETED": "Form left incomplete"
    },
    "TIMING": {
      "BEFORE": "Before",
      "AFTER": "After"
    },
    "UNITS": {
      "MINUTES": "minutes",
      "HOURS": "hours",
      "DAYS": "days"
    },
    "STATUS": {
      "ACTIVE": "Active",
      "PAUSED": "Paused",
      "AUTO_DISABLED": "Auto-disabled"
    },
    "EXECUTION_STATUS": {
      "PENDING": "Pending",
      "PROCESSING": "Processing",
      "SENT": "Completed",
      "FAILED": "Failed",
      "CANCELLED": "Cancelled"
    },
    "TABS": {
      "DEFINITIONS": "Flows",
      "EXECUTIONS": "Executions"
    },
    "EXECUTIONS": {
      "NO_EXECUTIONS": "No executions found.",
      "FILTER_ALL": "All",
      "OPEN_DETAILS": "Open details",
      "DETAILS_TITLE": "Flow execution details",
      "COLUMNS": {
        "FLOW": "Flow",
        "SCHEDULED_AT": "Scheduled for",
        "RUN_AT": "Run at",
        "RETRIES": "Retries",
        "TARGET": "Target",
        "ERROR": "Error"
      }
    },
    "CHANNEL": {
      "AUTO": "Client preferred"
    },
    "MODAL": {
      "ADD_TITLE": "Create Flow",
      "EDIT_TITLE": "Edit Flow",
      "SUBTITLE": "Set up an automated message for your customers.",
      "GENERAL": "General",
      "TITLE": "Title",
      "TITLE_PLACEHOLDER": "e.g. Appointment reminder after 24h",
      "DESCRIPTION": "Description",
      "DESCRIPTION_PLACEHOLDER": "Internal notes (optional)",
      "TRIGGER": "Trigger event",
      "TRIGGER_PLACEHOLDER": "Select one or more triggers...",
      "TIMING": "Timing",
      "BEFORE_AFTER": "Before / After",
      "NUMBER": "Number",
      "TIME_UNIT": "Unit",
      "MESSAGE": "Message",
      "MESSAGE_TEMPLATE": "Reference message",
      "MESSAGE_PLACEHOLDER": "Hello {name}, your appointment is on {date} at {start_time}.",
      "PLACEHOLDER_SELECT_LABEL": "Insert placeholder",
      "ADD_PLACEHOLDER": "Add",
      "PLACEHOLDERS_HINT": "Placeholders: {name}, {last_name}, {full_name}, {date}, {start_time}, {end_time}, {treatment}, {phone}, {mail}, {form_link}, {form_name}, {conversation_link}, {conversation_id}",
      "CHANNEL": "Delivery channel",
      "CHANNEL_OVERRIDE": "Channel",
      "CREATE": "Create",
      "SAVE": "Save"
    },
    "TEST": {
      "TITLE": "Send Test",
      "SUBTITLE": "Send a test message immediately to selected team members.",
      "SELECT_RECIPIENTS": "Select recipients...",
      "SEND": "Send Test"
    }
  },
  "FLOOR_PLAN": {
    "ROOMS": "Rooms",
    "ROOM_DRAG_HANDLE_ARIA": "Drag to reorder room",
    "ERROR_REORDER_ROOMS": "Could not save room order.",
    "ROOM_BLOCK": "Block room",
    "ROOM_BLOCK_CONFIRM_TITLE": "Block this room?",
    "ROOM_BLOCK_CONFIRM_MESSAGE": "Room «{{name}}» will not accept bookings or move targets while blocked. Tables and combinations stay visible but disabled.",
    "ROOM_UNBLOCK": "Unblock room",
    "ROOM_UNBLOCK_CONFIRM_TITLE": "Reactivate this room?",
    "ROOM_UNBLOCK_CONFIRM_MESSAGE": "Room «{{name}}» will be available again for bookings and moves.",
    "ROOM_BLOCKED_BADGE": "Blocked",
    "ROOM_BLOCKED_HINT": "This room is blocked: no bookings or moves into this room. Tables and combinations stay visible but are disabled.",
    "ROOM_BLOCKED_TOAST": "Room blocked.",
    "ROOM_UNBLOCKED_TOAST": "Room unblocked.",
    "ERROR_TOGGLE_ROOM_BLOCK": "Could not update room block status.",
    "ROOM_NAME": "Room name",
    "ROOM_DESCRIPTION": "Description",
    "ROOM_COLOR": "Room color",
    "ADD_ROOM_TITLE": "Create room",
    "EDIT_ROOM_TITLE": "Edit room",
    "SAVE_ROOM": "Save room",
    "ADD_SECTION": "Add",
    "ADD_PANEL_TITLE": "Add to this room",
    "ADD_PANEL_TABLE": "Table",
    "ADD_PANEL_COMPONENT": "Layout component",
    "ADD_TABLE_BLOCK": "Add table",
    "ADD_NEW_TABLE": "Add New Table",
    "EDIT_TABLE_TITLE": "Edit table",
    "SAVE_TABLE": "Save table",
    "ADD_COMPONENT_BLOCK": "Add component",
    "ADD_COMPONENT": "Add Component",
    "ADD_NEW_COMPONENT": "Add New Component",
    "EDIT_COMPONENT_TITLE": "Edit component",
    "SAVE_COMPONENT": "Save component",
    "COMPONENT_NAME": "Name",
    "COMPONENT_NAME_PLACEHOLDER": "e.g. Main Entrance, Kitchen Door",
    "COMPONENT_TYPE": "Type",
    "COMPONENT_COLOR": "Color",
    "CREATE_COMPONENT": "Create",
    "COMPONENT_CREATED": "Component created successfully.",
    "COMPONENT_UPDATED": "Component updated successfully.",
    "COMPONENT_DELETED": "Component deleted successfully.",
    "COMPONENT_TYPE_DOOR": "Door",
    "COMPONENT_TYPE_WINDOW": "Window",
    "COMPONENT_TYPE_BATHROOM": "Bathroom",
    "COMPONENT_TYPE_KITCHEN": "Kitchen",
    "COMPONENT_TYPE_BAR": "Bar",
    "COMPONENT_TYPE_STAIRS": "Stairs",
    "COMPONENT_TYPE_PILLAR": "Pillar",
    "COMPONENT_TYPE_GENERIC": "Generic",
    "ADD_ROOM": "Add room",
    "NO_ROOMS": "No rooms yet",
    "TABLES": "tables",
    "SEATS": "seats",
    "EDIT_LAYOUT": "Edit layout",
    "VIEW_MODE": "View mode",
    "SEARCH_TABLE": "Search table",
    "FILTER_ALL": "All statuses",
    "RESET_VIEW": "Reset view",
    "ZOOM_IN": "Zoom in",
    "ZOOM_OUT": "Zoom out",
    "ZOOM_LEVEL": "Zoom: {{pct}}% (you can also use the mouse wheel on the canvas)",
    "TABLE_NAME": "Table name",
    "LAYOUT_TOOLS": "Layout tools",
    "TABLE_NAME_LABEL": "Table name",
    "TABLE_NAME_PLACEHOLDER": "e.g. Table 12",
    "TABLE_NUMBER": "Table Number",
    "TABLE_NUMBER_PLACEHOLDER": "e.g. 1, A1, VIP-1",
    "TABLE_DISPLAY_NAME": "Display name",
    "TABLE_DISPLAY_NAME_PLACEHOLDER": "Shown large on the floor plan",
    "TABLE_CODE_AUTO_HINT": "A unique code (e.g. T-001) is assigned automatically when the table is created. It cannot be changed.",
    "TABLE_CODE_LABEL": "Code",
    "TABLE_COLOR": "Table color",
    "TABLE_SEATS_LABEL": "Seats (number)",
    "MIN_SEATS": "Min Seats",
    "MIN_SEATS_INVALID": "Minimum seats cannot be greater than seats.",
    "TABLE_SHAPE_LABEL": "Table shape",
    "ADD_TABLE": "Add table",
    "DECORATIONS_TITLE": "Decorations (soon)",
    "DECORATIONS_HINT": "Plants, walls and columns will be available in this section.",
    "SHAPE_ROUND": "Round",
    "SHAPE_SQUARE": "Square",
    "SHAPE_RECTANGLE": "Rectangle",
    "SHAPE_RECTANGLE_SHORT": "Rect",
    "NO_TABLES": "No tables in this room",
    "NO_TABLES_MATCH_SEARCH": "No tables match your search.",
    "CREATE_COMBINATION": "Create combination",
    "STATUS_FREE": "Free",
    "STATUS_RESERVED": "Reserved",
    "STATUS_OCCUPIED": "Occupied",
    "STATUS_BLOCKED": "Blocked",
    "ROOM_CREATED": "Room created successfully.",
    "ROOM_DELETED": "Room deleted successfully.",
    "TABLE_CREATED": "Table created successfully.",
    "TABLE_UPDATED": "Table updated successfully.",
    "TABLE_DELETED": "Table deleted successfully.",
    "DELETE_TABLE_CONFIRM_TITLE": "Delete table",
    "DELETE_TABLE_CONFIRM_MESSAGE": "Are you sure you want to delete table {{name}}?",
    "COMBINATION_CREATED": "Combination created successfully.",
    "COMBINATION_DELETED": "Combination deleted successfully.",
    "ERROR_LOAD_ROOMS": "Could not load rooms.",
    "ERROR_CREATE_ROOM": "Could not create room.",
    "ERROR_UPDATE_ROOM": "Could not update room.",
    "ERROR_DELETE_ROOM": "Could not delete room.",
    "ERROR_LOAD_TABLES": "Could not load tables.",
    "ERROR_LOAD_COMBINATIONS": "Could not load table combinations.",
    "ERROR_LOAD_ROOM_LAYOUT": "Could not load room layout (tables, combinations or components).",
    "ERROR_CREATE_COMPONENT": "Could not create layout component.",
    "ERROR_UPDATE_COMPONENT": "Could not update layout component.",
    "ERROR_DELETE_COMPONENT": "Could not delete layout component.",
    "ERROR_CREATE_TABLE": "Could not create table.",
    "ERROR_UPDATE_TABLE": "Could not update table.",
    "ERROR_DELETE_TABLE": "Could not delete table.",
    "ERROR_CREATE_COMBINATION": "Could not create combination.",
    "COMBINATIONS_TITLE": "Table combinations",
    "COMBINATIONS_EMPTY": "No combinations in this room. In edit mode, use Ctrl+click (⌘ on Mac) on tables to select them, then add a combination.",
    "COMBINATION_NEW_TITLE": "New combination",
    "COMBINATION_EDIT_TITLE": "Edit combination",
    "COMBINATION_NAME": "Combination name",
    "COMBINATION_NAME_PLACEHOLDER": "e.g. Banquet A, Large party",
    "COMBINATION_DISPLAY_NAME": "Display name",
    "COMBINATION_DISPLAY_NAME_PLACEHOLDER": "Shown in lists and when highlighting on the plan",
    "COMBINATION_CODE_AUTO_HINT": "A unique code (e.g. C-001) is assigned automatically when the combination is created. It cannot be changed.",
    "COMBINATION_CODE_LABEL": "Code",
    "COMBINATION_COLOR": "Combination color",
    "COMBINATION_MIN_PARTY": "Min guests (party size)",
    "COMBINATION_MAX_PARTY": "Max guests (party size)",
    "COMBINATION_PARTY_HINT": "Bookable party size for this combination — not tied to the sum of table seats. Allowed values: 1–99 each.",
    "COMBINATION_BOOKABLE_RANGE": "Bookings {{min}}–{{max}} guests",
    "COMBINATION_PARTY_MIN_MAX_INVALID": "Minimum guests cannot be greater than maximum.",
    "COMBINATION_PARTY_BOUNDS_INVALID": "Min and max guests must be between 1 and 99.",
    "COMBINATION_PARTY_CAPACITY_INVALID": "Guest range must be between 1 and {{cap}} (total seats of selected tables).",
    "ERROR_COMBINATION_PARTY_MIN": "Minimum guests must be between 1 and 99.",
    "ERROR_COMBINATION_PARTY_MAX": "Maximum guests must be between 1 and 99.",
    "ERROR_COMBINATION_PARTY_CAPACITY": "Guest range cannot exceed the combination’s total seats.",
    "ERROR_COMBINATION_PARTY_MAX_BOUND": "Min and max guests must be at most 99.",
    "ERROR_COMBINATION_MIN_SEATS": "The combination must have at least 2 total seats.",
    "COMBINATION_TABLES_PICK": "Tables in this room",
    "COMBINATION_TOTAL_SEATS_PREVIEW": "Total seats (preview)",
    "COMBINATION_USE_CANVAS_SELECTION": "Use current canvas selection",
    "COMBINATION_USE_CANVAS_SELECTION_EDIT_MODE": "Turn on “Edit layout” to multi-select tables on the plan (Ctrl+click, ⌘ on Mac), then use this button.",
    "COMBINATION_NEED_TWO_TABLES": "Select at least two tables.",
    "COMBINATION_NON_COMBINABLE_NOTE": "Not combinable — enable on the table card.",
    "COMBINATION_SAVE": "Save combination",
    "COMBINATION_UPDATED": "Combination updated successfully.",
    "TABLE_COMBINABLE": "Table can be combined",
    "TABLE_COMBINABLE_HINT": "Only combinable tables can be grouped into a named combination for bookings.",
    "DELETE_COMBINATION_CONFIRM_TITLE": "Delete combination",
    "DELETE_COMBINATION_CONFIRM_MESSAGE": "Delete combination {{name}}? Tables stay in the room.",
    "MULTI_SELECT_HINT": "In edit mode: Ctrl+click (⌘ on Mac) on a table to add or remove it from the canvas selection. Use it when building combinations.",
    "MULTI_SELECT_HINT_SHORT": "Ctrl+click (⌘) table: multi-select",
    "COMBINATION_BADGE_TOOLTIP": "In {{count}} combination(s)",
    "COMBINATION_HIGHLIGHT_ON_PLAN": "Highlight these tables on the plan (click again to clear)",
    "ERROR_COMBINATION_DUPLICATE_NAME": "A combination with this name already exists in this room.",
    "ERROR_COMBINATION_MIN_TABLES": "A combination must include at least two distinct tables.",
    "ERROR_COMBINATION_INVALID_TABLES": "Some tables are invalid or belong to another room.",
    "ERROR_COMBINATION_NOT_COMBINABLE": "One or more tables are not combinable.",
    "ERROR_COMBINATION_BOOKINGS": "This action is blocked because there are future bookings linked to this room or table.",
    "RESIZE_TABLE": "Resize table",
    "RESIZE_COMPONENT": "Resize component",
    "SNAP_GRID_ON": "Snap grid: on",
    "SNAP_GRID_OFF": "Snap grid: off",
    "NO_CLIP_ON": "No clip: on — tables and components can overlap (canvas bounds still apply). Turn off when done redesigning.",
    "NO_CLIP_OFF": "No clip: off — spacing only between tables; layout components may overlap each other and tables.",
    "ADVANCED": "Advanced",
    "ADVANCED_ARIA": "Advanced layout options",
    "ADVANCED_SNAP": "Snap to grid",
    "ADVANCED_NO_CLIP": "No clip",
    "CANVAS_SHRINK_WIDTH": "Decrease canvas width",
    "CANVAS_GROW_WIDTH": "Increase canvas width",
    "CANVAS_SHRINK_HEIGHT": "Decrease canvas height",
    "CANVAS_GROW_HEIGHT": "Increase canvas height",
    "CANVAS_WIDTH": "Canvas width",
    "CANVAS_HEIGHT": "Canvas height",
    "LIVE_TITLE": "Dining room (live)",
    "LIVE_SUBTITLE": "Live plan — tap a table to add bookings, mark guests seated, or block the table. Colors follow reservations and the current time.",
    "LIVE_TAB_FLOOR": "Floor plan",
    "LIVE_TAB_LIST": "Reservation list",
    "LIVE_TAB_ELENCO": "By table",
    "LIVE_VIEW_TABS_ARIA": "Choose live view: floor plan or list",
    "LIVE_ACTIONS_ARIA": "Booking actions: auto book and search all reservations",
    "LIVE_LIST_HEADING": "Reservations",
    "LIVE_LIST_HINT": "Tap a row to open the table and manage the booking. Change the date in the sidebar.",
    "LIVE_LIST_EMPTY_ROOM": "No reservations for this room on the selected date.",
    "LIVE_LIST_TIMELINE_LEGEND": "Slot in the day ({{start}}–{{end}})",
    "LIVE_LIST_ROW_ARIA": "{{start}} to {{end}}, {{title}}, {{place}}{{codePart}}. Open table.",
    "LIVE_LIST_PLACEMENT_TABLE": "Table {{name}}",
    "LIVE_LIST_PLACEMENT_COMBO": "Combination {{name}}",
    "LIVE_LIST_TABLE_CAPTION": "Table",
    "LIVE_LIST_TABLE_COMBO_DETAIL": "{{combo}} — {{tables}}",
    "LIVE_LIST_TABLE_UNSPECIFIED": "Not assigned",
    "LIVE_LIST_PLACEMENT_UNSPEC": "Placement not set",
    "LIVE_LIST_OPEN_ERROR": "No table could be opened for this booking.",
    "LIVE_BOOKING_CODE": "Booking code",
    "LIVE_SEARCH_LABEL": "Search",
    "LIVE_SEARCH_PLACEHOLDER": "Table, combo, booking code, title or guest…",
    "LIVE_SEARCH_CLEAR": "Clear search",
    "LIVE_LIST_SEARCH_EMPTY": "No reservations match your search. Try another table, guest or booking code.",
    "LIVE_FLOOR_SEARCH_EMPTY": "No tables in this room match your search. Clear the search or try another name or booking code.",
    "LIVE_DATE": "Date",
    "LIVE_REFRESH": "Refresh",
    "LIVE_ROOM_LAYOUT_LOADING": "Loading room layout…",
    "LIVE_TABLE_SHEET_TITLE": "Table {{name}}",
    "LIVE_ADD_RESERVATION": "Add reservation",
    "LIVE_ADD_WALKIN": "Add walk-in / seated",
    "LIVE_RESERVE_TABLE": "Reserve",
    "LIVE_AUTO_RES_OPEN": "Auto book",
    "LIVE_AUTO_RES_TITLE": "Automatic reservation",
    "LIVE_AUTO_RES_HINT": "Enter details and find the best-fit available table in selected rooms.",
    "LIVE_AUTO_RES_DATE": "Reservation date",
    "LIVE_AUTO_RES_DATE_INVALID": "Choose a valid reservation date.",
    "LIVE_AUTO_RES_ROOMS": "Rooms to search",
    "LIVE_AUTO_RES_ROOMS_PLACEHOLDER": "Select rooms",
    "LIVE_AUTO_RES_ROOMS_REQUIRED": "Select at least one room.",
    "LIVE_AUTO_RES_FIND": "Find table",
    "LIVE_AUTO_RES_FOUND": "Suggested table",
    "LIVE_AUTO_RES_FOUND_TABLE": "Table: {{table}}",
    "LIVE_AUTO_RES_FOUND_COMBO": "Table combination: {{name}}",
    "LIVE_AUTO_RES_FOUND_COMBO_TABLES": "Tables: {{tables}}",
    "LIVE_AUTO_RES_FOUND_ROOM": "Room: {{room}}",
    "LIVE_AUTO_RES_FOUND_TIME": "Time: {{start}}-{{end}}",
    "LIVE_AUTO_RES_CONFIRM": "Confirm reservation",
    "LIVE_AUTO_RES_FIND_ANOTHER": "Find another table",
    "LIVE_AUTO_RES_NO_TABLE": "No table available for these filters.",
    "LIVE_AUTO_RES_NO_MORE_TABLES": "No more alternative tables available.",
    "LIVE_AUTO_RES_LOOKUP_ERROR": "Could not search available tables.",
    "LIVE_AUTO_RES_SUMMARY_TITLE": "Reservation confirmed",
    "LIVE_AUTO_RES_SUMMARY_TABLE": "Table: {{table}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO": "Combination: {{name}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO_TABLES": "Tables: {{tables}}",
    "LIVE_AUTO_RES_SUMMARY_ROOM": "Room: {{room}}",
    "LIVE_AUTO_RES_SUMMARY_TIME": "Time: {{start}}-{{end}}",
    "LIVE_AUTO_RES_SUMMARY_GUEST": "Guest: {{guest}}",
    "LIVE_GLOBAL_RES_OPEN": "Search bookings",
    "LIVE_GLOBAL_RES_TITLE": "Reservation search",
    "LIVE_GLOBAL_RES_HINT": "Search by booking code, guest name, or table/combination name. Includes all dates and statuses (closed and seated).",
    "LIVE_GLOBAL_RES_FIELD_LABEL": "Search text",
    "LIVE_GLOBAL_RES_PLACEHOLDER": "Code, guest name, table…",
    "LIVE_GLOBAL_RES_SEARCH": "Search",
    "LIVE_GLOBAL_RES_OPEN_HINT": "Tap to open the table on that booking’s date.",
    "LIVE_GLOBAL_RES_EMPTY": "No reservations found.",
    "LIVE_GLOBAL_RES_INITIAL": "Enter at least 2 characters and tap Search.",
    "LIVE_GLOBAL_RES_QUERY_SHORT": "Enter at least 2 characters.",
    "LIVE_GLOBAL_RES_ERROR": "Search failed. Please try again.",
    "LIVE_GLOBAL_RES_OPEN_NO_TABLE": "Cannot open: no table linked to this reservation.",
    "LIVE_BLOCK_TABLE": "Block table",
    "LIVE_UNBLOCK_TABLE": "Unblock table",
    "LIVE_RELEASE_DAY": "Clear all bookings (day)",
    "LIVE_MARK_SEATED": "Guest arrived",
    "LIVE_MARK_SEATED_SUCCESS": "Marked as seated.",
    "LIVE_MARK_SEATED_ERROR": "Could not update seating.",
    "LIVE_RELEASE_TABLE_EARLY": "Free table — guests have left before the end of the booking",
    "LIVE_RELEASE_TABLE_EARLY_TITLE": "Free table",
    "LIVE_RELEASE_TABLE_EARLY_SUB": "Guests left · ends this booking now",
    "LIVE_RELEASE_EARLY_SUCCESS": "Table freed. Booking closed at the selected end time.",
    "LIVE_RELEASE_EARLY_ERROR": "Could not free the table.",
    "LIVE_RELEASE_CHOICE_TITLE": "Table in use",
    "LIVE_RELEASE_CHOICE_BODY": "Did the guests leave? Close the booking with the current time as the end. Or if you marked arrival by mistake, undo only the arrival — the booking stays as reserved.",
    "LIVE_RELEASE_CHOICE_UNDO": "Undo arrival (not seated)",
    "LIVE_RELEASE_CHOICE_CLOSE": "Guests left — close booking",
    "LIVE_UNDO_ARRIVAL_SUCCESS": "Arrival undone. The booking is reserved again as before.",
    "LIVE_UNDO_ARRIVAL_ERROR": "Could not undo arrival.",
    "LIVE_GUEST_SEATED_BADGE": "Seated",
    "LIVE_RES_COMBO_BADGE": "Combination",
    "LIVE_RES_PARTIAL_BADGE": "Partial stay",
    "LIVE_RES_PLACEMENT_MISSING": "Placement missing",
    "LIVE_VISUAL_BLOCKED": "Blocked",
    "LIVE_VISUAL_FREE": "Available (now)",
    "LIVE_VISUAL_WAITING": "Reserved — waiting",
    "LIVE_VISUAL_SEATED": "Guests seated",
    "LIVE_VISUAL_DAY_BOOKED": "Has bookings (this day)",
    "LIVE_CANCEL_RESERVATION": "Cancel this booking",
    "LIVE_CANCEL_RESERVATION_SUCCESS": "Booking cancelled.",
    "LIVE_CANCEL_RESERVATION_ERROR": "Could not cancel the booking.",
    "LIVE_EDIT_RESERVATION": "Edit booking",
    "LIVE_EDIT_RESERVATION_TITLE": "Edit booking",
    "LIVE_EDIT_RESERVATION_HINT": "Pick the date first, then a start time based on availability. You can also update party size and notes. When guests are seated, only notes can be changed.",
    "LIVE_EDIT_RES_DATE": "Reservation date",
    "LIVE_EDIT_RES_DATE_HINT": "After you change the day, available start times refresh automatically.",
    "LIVE_EDIT_START_INVALID_FOR_DATE": "Choose a start time from the available slots for the selected date (or change date or party size and try again).",
    "LIVE_EDIT_GUEST_SEATED_HINT": "Guests are seated: you can only update notes. To change time or table, free the table first.",
    "LIVE_EDIT_SUCCESS": "Booking updated.",
    "LIVE_EDIT_ERROR": "Could not update the booking.",
    "LIVE_EDIT_NO_CHANGES": "No changes to save.",
    "LIVE_MOVE_RESERVATION": "Move to another table",
    "LIVE_MOVE_RESERVATION_TITLE": "Move booking",
    "LIVE_MOVE_RESERVATION_HINT": "Pick another table in any room. Same time slot and duration (must be free, including combo holds).",
    "LIVE_MOVE_RESERVATION_HINT_COMBO": "Pick another combination or single table in any room. Same time slot and duration; all tables at the destination must be free.",
    "LIVE_MOVE_TARGET_DESTINATION": "Destination",
    "LIVE_MOVE_TARGET_REQUIRED": "Select a destination.",
    "LIVE_MOVE_OPTION_COMBO_TITLE": "{{name}} — combo · {{seats}} seats",
    "LIVE_MOVE_OPTION_COMBO_SUB": "{{room}} · {{slot}} · {{party}} guests · Tables: {{tables}}",
    "LIVE_MOVE_OPTION_TITLE": "{{name}} — max {{seats}} seats",
    "LIVE_MOVE_OPTION_SUB": "{{room}} · Slot {{slot}} · {{party}} guests (fits this booking)",
    "LIVE_MOVE_TARGETS_LOADING": "Finding tables available for this time slot…",
    "LIVE_MOVE_TARGETS_ERROR": "Could not load tables for the move.",
    "LIVE_MOVE_SEARCH_PLACEHOLDER": "Search by table or room…",
    "LIVE_MOVE_TARGET_TABLE": "Target table",
    "LIVE_MOVE_SUBMIT": "Move",
    "LIVE_MOVE_SUCCESS": "Booking moved.",
    "LIVE_MOVE_ERROR": "Could not move the booking.",
    "LIVE_MOVE_TABLE_REQUIRED": "Select a target table.",
    "LIVE_MOVE_NO_TARGETS": "No compatible table in any room: enough seats and a free slot for this time range.",
    "LIVE_MOVE_NO_TARGETS_COMBO": "No compatible combination or table in any room: allowed party size and a free slot on all involved tables.",
    "LIVE_MOVE_NO_TARGETS_ONLY_ONE_COMBO": "The venue has only the current combination «{{comboName}}» in room «{{room}}» ({{totalSeats}} physical seats). To move {{party}} guests, create another combination (in any room) in the floor-plan editor. Single tables seat at most {{maxTableSeats}} each.",
    "LIVE_RESERVATIONS": "Reservations",
    "LIVE_RES_COVERS": "{{count}} guests",
    "LIVE_RES_FINISHED": "Finished",
    "LIVE_RES_FINISHED_NOTE": "Closed · slot {{start}}–{{end}}",
    "LIVE_RESERVATIONS_BADGE": "bookings",
    "LIVE_NO_RESERVATIONS": "No reservations for this day.",
    "LIVE_COMBINATIONS": "Combinations",
    "LIVE_COMBOS_SHORT": "combo",
    "LIVE_TABLE_SEATS_TOOLTIP": "{{count}} covers",
    "LIVE_TABLE_RES_TOOLTIP": "{{count}} bookings for this day",
    "LIVE_STATUS_ACTIONS": "Table status",
    "LIVE_STATUS_LABEL": "Status",
    "LIVE_CYCLE_STATUS": "Next status",
    "LIVE_FREE_CONFIRM_TITLE": "Cancel bookings?",
    "LIVE_FREE_CONFIRM_BODY": "Table {{name}} has bookings for this day. Set it to Free and cancel those reservations? This cannot be undone from here.",
    "LIVE_FREE_CONFIRM_SUBMIT": "Cancel bookings and set Free",
    "LIVE_FREE_CONFIRM_BACK": "Keep current status",
    "LIVE_FREE_SUCCESS": "Bookings cancelled and table set to Free.",
    "LIVE_FREE_ERROR": "Could not release the table.",
    "LIVE_NOTES": "Staff notes",
    "LIVE_ERROR_LOAD": "Could not load live overview.",
    "LIVE_OPEN_EDITOR": "Open floor plan editor",
    "MANUAL_RES_TITLE": "Table booking — {{status}}",
    "MANUAL_RES_TITLE_RESERVE": "New table reservation",
    "MANUAL_RES_HINT": "Creates a timed reservation for this guest. Table colors in live view come from bookings and the current time.",
    "MANUAL_RES_START": "Time",
    "MANUAL_RES_END": "End time (optional)",
    "MANUAL_RES_END_HINT": "Leave empty to use the default reservation length from chatbot/dining settings.",
    "MANUAL_RES_DURATION_HINT": "End time is set automatically from your restaurant reservation length.",
    "MANUAL_RES_SLOTS_LOADING": "Loading available times…",
    "MANUAL_RES_SLOTS_EMPTY": "No bookable times for this day, party size, or table. Check restaurant settings or table availability.",
    "MANUAL_RES_SLOTS_LOAD_ERROR": "Could not load bookable times.",
    "MANUAL_RES_PARTY": "Party size",
    "MANUAL_RES_COMBO_SELECT": "Table combination",
    "MANUAL_RES_COMBO_SINGLE_HINT": "Booking uses the combination “{{name}}” (all linked tables are held for this slot).",
    "MANUAL_RES_NOTES": "Notes (optional)",
    "MANUAL_RES_GUEST_CONTACT": "Guest / contact",
    "MANUAL_RES_GUEST_PLACEHOLDER": "Choose a contact or walk-in",
    "MANUAL_RES_SEARCH_CONTACTS": "Search contacts…",
    "MANUAL_RES_CREATE_CONTACT": "+ New contact",
    "MANUAL_RES_NO_CONTACT": "No name / walk-in",
    "MANUAL_RES_FILL_GUEST": "Select a contact or walk-in.",
    "MANUAL_RES_WALK_IN_DISPLAY": "Walk-in (no contact)",
    "MANUAL_RES_CONTACT_MODE": "Guest",
    "MANUAL_RES_EXISTING": "Existing contact",
    "MANUAL_RES_NEW": "New contact",
    "MANUAL_RES_SELECT_CONTACT": "Select contact",
    "MANUAL_RES_FIRST": "First name",
    "MANUAL_RES_LAST": "Last name",
    "MANUAL_RES_PHONE": "Phone",
    "MANUAL_RES_EMAIL": "Email (optional)",
    "MANUAL_RES_SUBMIT": "Save reservation",
    "MANUAL_RES_CANCEL": "Cancel",
    "MANUAL_RES_FILL_CONTACT": "Select a contact.",
    "MANUAL_RES_FILL_NEW": "First name, last name and phone are required.",
    "MANUAL_RES_START_REQUIRED": "Please select a time.",
    "MANUAL_RES_SUCCESS": "Reservation saved.",
    "MANUAL_RES_ERROR": "Could not save the reservation.",
    "MANUAL_RES_CONTACTS_LOAD_ERROR": "Could not load contacts.",
    "LIVE_APPT_STATUS_CONFIRMED": "Confirmed",
    "LIVE_APPT_STATUS_PENDING": "Pending",
    "LIVE_APPT_STATUS_COMPLETED": "Completed",
    "LIVE_APPT_STATUS_CANCELLED": "Cancelled",
    "LIVE_APPT_STATUS_CANCELLED_BY_CLIENT": "Cancelled by client",
    "LIVE_APPT_STATUS_NO_SHOW": "No show",
    "ANALYTICS_TITLE": "Dining analytics",
    "ANALYTICS_SUBTITLE": "Bookings and table usage for the selected period (UTC dates).",
    "ANALYTICS_FROM": "From",
    "ANALYTICS_TO": "To",
    "ANALYTICS_PRESET_7D": "Last 7 days",
    "ANALYTICS_PRESET_30D": "Last 30 days",
    "ANALYTICS_APPLY": "Apply",
    "ANALYTICS_LOADING": "Loading analytics…",
    "ANALYTICS_ERROR": "Could not load analytics. Check the date range and try again.",
    "ANALYTICS_KPI_TOTAL": "Total bookings",
    "ANALYTICS_KPI_WITH_TABLE": "With table assigned",
    "ANALYTICS_KPI_WITH_COMBO": "With table combination",
    "ANALYTICS_KPI_CONFIRMED": "Confirmed",
    "ANALYTICS_KPI_NO_SHOW": "No show",
    "ANALYTICS_KPI_CANCELLED": "Cancelled (all)",
    "ANALYTICS_CHART_BOOKINGS": "Bookings by day",
    "ANALYTICS_CHART_STATUS": "By status",
    "ANALYTICS_CHART_HOUR": "Bookings by hour (start time)",
    "ANALYTICS_CHART_TOP_TABLES": "Top tables",
    "ANALYTICS_CHART_DAY_STATUS": "Table operational status by day",
    "ANALYTICS_TOP_TABLES": "Top tables",
    "ANALYTICS_TOP_ROOMS": "Top rooms",
    "ANALYTICS_RECENT": "Recent bookings",
    "ANALYTICS_UNFULFILLED_TITLE": "Chat: unfulfilled table requests",
    "ANALYTICS_UNFULFILLED_HINT": "Logged when the chatbot found no table after searching the requested time and ±30 minutes.",
    "ANALYTICS_UNFULFILLED_EMPTY": "No unfulfilled chat requests recorded.",
    "ANALYTICS_UNFULFILLED_COL_WHEN": "Logged at",
    "ANALYTICS_UNFULFILLED_COL_PARTY": "Guests",
    "ANALYTICS_UNFULFILLED_COL_OFFSETS": "Offsets tried (min)",
    "ANALYTICS_NO_DATA": "No data for this period.",
    "ANALYTICS_COL_TABLE": "Table",
    "ANALYTICS_COL_ROOM": "Room",
    "ANALYTICS_COL_COUNT": "Count",
    "ANALYTICS_COL_DATE": "Date",
    "ANALYTICS_COL_TIME": "Time",
    "ANALYTICS_COL_TITLE": "Title",
    "ANALYTICS_COL_STATUS": "Status"
  }
}
